import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import { TextField, Button, Paper, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import FormControlLabel from '@mui/material/FormControlLabel';
import styles from './index.styles';
import Boxlayout from '../assign-prescriptions/box-layout';
import randomized from 'randomatic';
import assignmentstatus from './assignment-status';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import DialogContentText from '@mui/material/DialogContentText';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { toast } from 'react-toastify';
import FormHelperText from '@mui/material/FormHelperText';
import PlayArrow from '@mui/icons-material/PlayArrow';
import PrintTemplate from 'react-print';
import EVENT_TYPES from '../common/event-type';
import EVENT_CRUD_TYPES from '../common/event-crud-types';
import EventLogHandler from '../common/event-log-handler';
import { DesktopDatePicker, LocalizationProvider } from '@mui/lab';
import DateAdapter from "@mui/lab/AdapterDateFns";
import { extendMoment } from 'moment-range';
import originalMoment from 'moment';
import AmountFormat from '../common/AmountFormat';
import HomeIcon from '@mui/icons-material/Home';
import WorkIcon from '@mui/icons-material/Work';
import curbsideIcon from '../iLocal-Delivery-Icons/Curbside.svg';
import counterIcon from '../iLocal-Delivery-Icons/Counter.svg';
import inpatientIcon from '../iLocal-Delivery-Icons/Bedside.svg';
import courierIcon from '../iLocal-Delivery-Icons/Courier.svg';
import LOCATION_TYPE from '../enum/location_type';
import DEVICE_TYPE from '../enum/device_type';
import spinner from './images/spinner.gif';
import checked from './images/checked.png';
import cl from './images/cl.gif';
import Manualconsultation from '../assign-prescriptions/Manual-consultation';
import InputAdornment from '@mui/material/InputAdornment';
import MagnifyIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import NumberFormat from 'react-number-format';
import BOX_TYPE from '../enum/box_type';
import io from 'socket.io-client';
import TablePagination from '@mui/material/TablePagination';
import '../assign-prescriptions/index.css';
import { IMaskInput } from 'react-imask';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import Box from '@mui/material/Box';
import LabelTemplate from '../assign-prescriptions/labelTemplate';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { withTranslation } from 'react-i18next';
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';
import userroles from '../common/userroles';

const mapLocationTypesHelper = (locationDetails, t) => {
  return locationDetails.map((type) => {
    if (type.locationtype_id === LOCATION_TYPE.Kiosk) {
      return { id: type.locationtype_id, label: t('API.LocationType.Kiosk') };
    }
    if (type.locationtype_id === LOCATION_TYPE.Home) {
      return { id: type.locationtype_id, label: t('API.LocationType.Home') };
    }
    if (type.locationtype_id === LOCATION_TYPE.Work) {
      return { id: type.locationtype_id, label: t('API.LocationType.Work') };
    }
    if (type.locationtype_id === LOCATION_TYPE.Courier) {
      return { id: type.locationtype_id, label: t('API.LocationType.Courier') };
    }
    if (type.locationtype_id === LOCATION_TYPE.Counter) {
      return { id: type.locationtype_id, label: t('API.LocationType.Counter') };
    }
    if (type.locationtype_id === LOCATION_TYPE.Curbside) {
      return { id: type.locationtype_id, label: t('API.LocationType.CurbSide') };
    }
    if (type.locationtype_id === LOCATION_TYPE.Bedside) {
      return { id: type.locationtype_id, label: t('API.LocationType.Bedside') };
    }
    if (type.locationtype_id === LOCATION_TYPE.Other) {
      return { id: type.locationtype_id, label: t('API.LocationType.Other') };
    }
    return type;
  });
};

const localeTheme = createTheme(
  {

  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);
const moment = extendMoment(originalMoment);
const uuidv4 = require('uuid/v4');

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask='(#00) 000-0000'
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

let searchedRxNumbers = [];
// let tosterMsg = false;
let nums = Array.from(Array(5).keys());
let nums1 = Array.from(Array(12).keys());
let elem = ['A', 'B', 'C', 'D', 'E'];
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === 'desc'
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

class EnhancedTableHead extends React.Component {
  createSortHandler = (property) => (event) => {
    this.props.onRequestSort(event, property);
  };

  handlePrescriptionResponse = (data, bin_info) => {
    // Shared handler to bind prescription response into component state
    if (!data || !data.response || !data.response.box) {
      const DefaultCartItem = {
        id: '-1',
        rxNo: '',
        drugname: '',
        ndcCode: '',
        price: '0.00',
        CoPayAmount: '0.00',
        qty: 0,
        ConsultRequire: false,
      };
      this.setState({
        searchedRxNo: [],
        searchedItems: [],
        rxNumber: '',
        selected: [],
        scanRxItems: [DefaultCartItem],
      });
      return;
    }

    const details = data.response.box;
    if (!details.customers || !details.customers.length) {
      const DefaultCartItem = {
        id: '-1',
        rxNo: '',
        drugname: '',
        ndcCode: '',
        price: '0.00',
        CoPayAmount: '0.00',
        qty: 0,
        ConsultRequire: false,
      };
      this.setState({
        searchedRxNo: [],
        searchedItems: [],
        rxNumber: '',
        selected: [],
        scanRxItems: [DefaultCartItem],
      });
      return;
    }

    // Preserve existing reminder data behavior
    if (bin_info) {
      this.setState({
        reminderData: { bin_info, data },
        isVisibleForPause: true,
      });
    }

    const basicDetails = details && details.customers[0];
    const orders = details && details.customers[0].orders[0];
    const typeId = orders.type_id;
    const stockcode = orders.stock_code;
    const pickupcode = orders.pucode;
    const rxItems = orders.items;
    const orderId = details && details.customers[0].orders[0].id;
    const rxNo = details && details.customers[0].orders[0].items[0].rx_no;
    const bindId = details && details.customers[0].orders[0].bin_id;
    const binSize = orders && orders.bin_size;
    const contactDetails = details && details.customers[0].contacts[0];
    const locationDetails = orders && orders.customerLocations;

    this.setState({
      stockCode: orders.stock_code,
      pickupCode: orders.pucode,
      locationDetails: locationDetails,
      basicDetails: basicDetails,
      contactDetails: contactDetails,
      PrintisCoolItem: orders['is_cool_item'],
      EmailID: contactDetails.email,
      phone: contactDetails.phone,
    });

    let address1;
    let address2;
    let city;
    let state;
    let zip;
    let country;
    let location_notes;

    if (locationDetails && locationDetails.length > 0) {
      const locationtypesdata = mapLocationTypesHelper(locationDetails, this.props.t);
      this.setState({
        locationtype: locationtypesdata,
        locationtype_id: locationtypesdata[0].id,
      });
      if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
        const boxData = this.state.boxdata;
        boxData.forEach((item) => {
          if (this.state.box_id === item.id && item && item.address) {
            address1 = item.address.address_line_1 || '';
            address2 = item.address.address_line_2 || '';
            city = item.address.city || '';
            state = item.address.state || '';
            zip = item.address.zip || '';
            country = item.address.country || '';
            location_notes = item.address.location_notes || '';
          }
        });
      } else {
        locationDetails.forEach((type) => {
          if (this.state.locationtype_id === type.locationtype_id) {
            address1 = type.addressline1;
            address2 = type.addressline2;
            city = type.city;
            state = type.state;
            zip = type.zip;
            country = type.country;
            location_notes = type.location_notes;
          }
        });
      }
    } else {
      if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
        const locationtypesdata = [
          { id: this.state.locationtype_id, label: this.props.t('API.LocationType.Kiosk') },
        ];
        this.setState({ locationtype: locationtypesdata });
        const boxData = this.state.boxdata;
        boxData.forEach((item) => {
          if (this.state.box_id === item.id && item && item.address) {
            address1 = item.address.address_line_1 || '';
            address2 = item.address.address_line_2 || '';
            city = item.address.city || '';
            state = item.address.state || '';
            zip = item.address.zip || '';
            country = item.address.country || '';
            location_notes = item.address.location_notes || '';
          }
        });
      }
    }

    if (typeId === DEVICE_TYPE.Hold) {
      this.setState({ isAlreadyOnHold: true });
    } else {
      this.setState({ isAlreadyOnHold: false });
    }
    if (typeId === DEVICE_TYPE.Assigned) {
      this.setState({ isAlreadyAssigned: true });
    } else {
      this.setState({ isAlreadyAssigned: false });
    }
    if (typeId === DEVICE_TYPE.Stocked) {
      this.setState({ is_stocked: true });
    } else {
      this.setState({ is_stocked: false });
    }

    let Patient = [];
    Patient.push({ id: basicDetails.id, name: basicDetails.name });
    let Arraycart = [];
    for (let i = 0; i < rxItems.length; i++) {
      let item = {};
      item.id = i;
      item.rxNo = rxItems[i].rx_no;
      item.drugname = rxItems[i].drug_name;
      item.ndcCode = rxItems[i].ndc_code;
      item.price = rxItems[i].price;
      item.qty = rxItems[i].qty;
      item.ConsultRequire = rxItems[i].is_consultrequire;
      item.orderid = rxItems[i].id;
      item.is_order_released = rxItems[i].is_order_released;
      Arraycart.push(item);
    }
    this.setState({
      isPatientSelectionDisabled: true,
      searchedItems: {
        FirstName: basicDetails.first_name,
        LastName: basicDetails.last_name,
        DateOfBirth: basicDetails.dob_str,
        MobileNo: this.state && this.state.phone,
        EmailID: this.state && this.state.EmailID,
        AddressLine1: address1,
        AddressLine2: address2,
        City: city,
        State: state,
        Zip: zip,
        Country: country,
        location_notes: location_notes,
        isCoolItem: orders && orders.is_cool_item,
      },
      rxNumber: rxNo,
      selectedBinId: bindId,
      selectedBinSize: binSize ? binSize : '',
      isBinSizeRequired: false,
      isBinIdRequired: false,
      stockCode: stockcode,
      pickupCode: pickupcode,
      orderId: orderId,
      selectedPatient: Patient[0],
      readOnly: true,
      scanRxItems: Arraycart,
      isPatientRecordNumberRequired: false,
    });
    this.getPaymentDetails(orderId, basicDetails.id);
    this.getCartRxNumbers();
    this.setState({ assignedPrescription: details });
    this.forceUpdate();
  };

  render() {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      isVisibleForPause,
      className,
      t,
    } = this.props;
    const rows = [
      {
        id: 'rxNo',
        numeric: false,
        disablePadding: false,
        label: t('Unplugged.RxHash'),
      },
      {
        id: 'drugname',
        numeric: false,
        disablePadding: false,
        label: t('Unplugged.DrugName'),
      },
      {
        id: 'ndcCode',
        numeric: false,
        disablePadding: false,
        label: t('Unplugged.NDCCode'),
      },
      {
        id: 'qty',
        numeric: false,
        disablePadding: false,
        label: t('Unplugged.Qty'),
      },
      {
        id: 'consultrequire',
        numeric: false,
        disablePadding: true,
        label: t('Unplugged.ConsultRequired'),
      },
      {
        id: 'price',
        numeric: false,
        disablePadding: false,
        label: t('Unplugged.Price'),
      },
      {
        id: 'isreturnable',
        numeric: false,
        disablePadding: true,
        label: t('Assign.IsReturnable'),
      },
      {
        id: 'iscontrolled',
        numeric: false,
        disablePadding: true,
        label: t('Assign.IsControlled'),
      }
    ];
    return (
      <TableHead>
        <TableRow style={{ height: '56px' }}>
          {!isVisibleForPause && (
            <TableCell
              padding='checkbox'
              style={{ padding: 0, textAlign: 'center' }}>
              <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={numSelected === rowCount}
                onChange={onSelectAllClick}
                style={{ color: '#4fc3f7' }}
              />
            </TableCell>
          )}
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === row.id ? order : false}
                className={className}
                style={{
                  textAlign: 'left',
                  ...(['Consult Required'].includes(row.label) && {
                    width: '33px',
                  }),
                  ...(['Qty'].includes(row.label) && { width: '55px' }),
                  ...(['Rx #'].includes(row.label) && { padding: '10px' }),
                }}>
                <Tooltip
                  title={t("Global.Label.Filter.Sort")}
                  placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}>
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}>
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func,
  order: PropTypes.string,
  orderBy: PropTypes.string,
  rowCount: PropTypes.number,
  className: PropTypes.object.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      }
      : {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  add: {
    //backgroundColor: theme.palette.secondary.main,
    backgroundColor: '#6cca98',
    color: '#fff',
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: '#6cca98',
      color: '#fff',
    },
  },
  gridActions: {
    display: 'inline-block',
    width: '144px',
  },
  deletePrimaryButton: {
    background: 'none',
    color: 'rgba(0, 0, 0, 0.54)',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
  },
});

let EnhancedTableToolbar = (props) => {
  const {
    numSelected,
    classes,
    /* add,  deleteUsers, editUser, viewUser, */ confirmDelete,
  } = props;

  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}>
      <div className={classes.title}>
        {numSelected > 0 && (
          <Typography color='inherit' variant='subheading'>
            {numSelected} selected
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected === 1 && (
          <div>
            {/* <div className={classes.gridActions}> */}
            <Tooltip key='single-delete' title='Delete'>
              <IconButton
                aria-label='Delete'
                onClick={confirmDelete}
                className={classes.deletePrimaryButton}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </div>
        )}
        {numSelected > 1 && (
          <Tooltip key='multi-delete' title='Delete'>
            <IconButton
              aria-label='Delete'
              onClick={confirmDelete}
              className={classes.deletePrimaryButton}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator
      prefix='$'
      decimalScale={2}
      allowNegative={false}
      decimalSeparator={'.'}
      fixedDecimalScale={true}
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

const legend = [
  { color: "linear-gradient(155deg, rgb(212,209,0) 0%, rgb(255,255,189) 90%)", label: "Assigned" },
  { color: "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(4, 144, 243) 90%)", label: "Hold" },
  { color: "linear-gradient(155deg, rgb(23,166,0) 0%, rgb(196,255,189) 90%)", label: "Stocked" },
  { color: "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)", label: "Deactivate" },
];

export class AssignPrescriptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rxDetails: [
        {
          PatientID: '100001',
          FirstName: 'John',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '51655-157',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123456',
                  name: 'Amoxicillan',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 10,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 10,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                  strength: '500 mg/1',
                  route: 'Oral',
                  doseage_form: 'Capsule',
                  non_proprietary_name: 'Amoxicillan',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100002',
          FirstName: 'Paul',
          LastName: 'Jones',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '0071-0155',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123457',
                  name: 'Lipitor',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 90,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 100,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                  strength: '10 mg/1',
                  route: 'Oral',
                  doseage_form: 'Tablet',
                  non_proprietary_name: 'atorvastatin calcium',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100003',
          FirstName: 'Nicole',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '55289-926',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123458',
                  name: 'Valtrex',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 30,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 75,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                  strength: '500 mg/1',
                  route: 'Oral',
                  doseage_form: 'Tablet',
                  non_proprietary_name: 'valacyclovir hydrochloride',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100001',
          FirstName: 'John',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '50742-189',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123459',
                  name: 'Prednisone',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 15,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 50,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100002',
          FirstName: 'Paul',
          LastName: 'Jones',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '51655-157',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123460',
                  name: 'Amoxicillan',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 10,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 10,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100003',
          FirstName: 'Nicole',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '0071-0155',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123461',
                  name: 'Lipitor',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 90,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 100,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100001',
          FirstName: 'John',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '55289-926',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123462',
                  name: 'Valtrex',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 30,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 75,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100002',
          FirstName: 'Paul',
          LastName: 'Jones',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '50742-189',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123463',
                  name: 'Prednisone',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 15,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 50,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100003',
          FirstName: 'Nicole',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '51655-157',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123464',
                  name: 'Amoxicillan',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 10,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 10,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
                {
                  ndcCode: '51655-157',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123444',
                  name: 'Amoxicillan',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 10,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 10,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100010',
          FirstName: 'Michael',
          LastName: 'Thomas',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '0071-0155',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123465',
                  name: 'Lipitor',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 90,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 100,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100011',
          FirstName: 'Joseph',
          LastName: 'Box',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '55289-926',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123466',
                  name: 'Valtrex',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 30,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 75,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100012',
          FirstName: 'Paul',
          LastName: 'Patient',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '50742-189',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123467',
                  name: 'Prednisone',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 15,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 50,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100013',
          FirstName: 'Paul',
          LastName: 'Patient',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '51655-157',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123468',
                  name: 'Amoxicillan',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 10,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 10,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100014',
          FirstName: 'Bryan',
          LastName: 'Rigney',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '0071-0155',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123469',
                  name: 'Lipitor',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 90,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 100,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100015',
          FirstName: 'Ivan',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '55289-926',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123470',
                  name: 'Valtrex',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 30,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 75,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100016',
          FirstName: 'Jonah',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '50742-189',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123471',
                  name: 'Prednisone',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 15,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 50,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100017',
          FirstName: 'Grayson',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '51655-157',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123472',
                  name: 'Amoxicillan',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 10,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 10,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100018',
          FirstName: 'Gabriel',
          LastName: 'Smith',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '0071-0155',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123473',
                  name: 'Lipitor',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 90,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 100,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100019',
          FirstName: 'Vishal',
          LastName: 'Zacharias',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'info@ilocalbox.com',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '55289-926',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'A123474',
                  name: 'Valtrex',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 30,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 75,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
        {
          PatientID: '100060',
          FirstName: 'Manav',
          LastName: 'Pandya',
          DateOfBirth: '11/11/2011',
          MobileNo: '9497677339',
          EmailID: 'manav.pandya@epistic.net',
          governmentIdNo: '',
          governmentIdType: '',
          relatives: [
            {
              patientId: '',
              relation: '',
            },
          ],
          orders: [
            {
              orderId: '03',
              pickupCode: 'A3A3A3',
              totalAmount: 300,
              taxPercentage: 3,
              insuranceAmount: 20,
              totalCoPayAmount: 40,
              totalPaidAmount: 40,
              totalDueAmount: 0,
              paymentDueDate: '',
              items: [
                {
                  ndcCode: '55289-926',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'Z123474',
                  name: 'Valtrex',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 30,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 75,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
                {
                  ndcCode: '55289-927',
                  itemId: '03',
                  binId: 'A3',
                  rxNo: 'Z123475',
                  name: 'Valtrex',
                  description: 'AZITHROMYCIN MONOHYDRATE',
                  image: '/static/dashboard/global_assets/images/placeholders/placeholder-30.svg',
                  potency: '500 mg/1',
                  qty: 30,
                  schedule: '',
                  Amount: 20,
                  taxPercentage: 3,
                  insuranceAmount: 0,
                  CoPayAmount: 75,
                  PaidAmount: 10,
                  DueAmount: 0,
                  paymentDueDate: '',
                  stockedOn: '',
                  stockedBy: '',
                  deStockedOn: '',
                },
              ],
            },
          ],
        },
      ],
      selectedBinId: '',
      stockCode: '',
      pickupCode: '',
      searchedRxNo: [],
      prescriptionMasterData: {},
      rxNumber: '',
      selected: [],
      box: [],
      hasError: false,
      box_id: null,
      pharmacyDetails: {},
      accountDetails: {},
      BinStatus: [],
      deactivatedBins: [],
      assignedPrescription: {},
      isVisibleForPause: false,
      isBoxSelected: false,
      selectedUnitName: '',
      customervalues: [],
      customerList: [],
      popupDOB: null,
      scanRxItems: [],
      copyScanRxItems: [],
      isPaymentRequired: false,
      CoPayAmountIndex: '',
      CoPayAmountValue: '0.00',
      readOnly: false,
      selectedPatient: {},
      expansionUnits: [
        {
          id: -1,
          order: 0,
          pos: 'M',
          selectedUnitIndex: 0,
          box_position: 0,
        },
      ],
      box_expansions_id: '',
      isADACompatible: false,
      locationtype_id: '',
      EmailID: '',
      phone: '',
      is_stocked: false,
      order: 'desc',
      orderBy: 'created_on',
      PrintFirstName: '',
      PrintLastName: '',
      ADAData: [],
      SearchResultDialogOpen: false,
      reminderData: [],
      source_location: '',
      delivery_notes: '',
      order_notes: '',
      patient_notes: '',
      boxdata: [],
      prefer_location_name: '',
      courier_type: [],
      courier_tracking: '',
      default_courier_selected: '',
      isEdit: false,
      indexNo: null,
      page: 0,
      rowsPerPage: 10,
      printDialogOpen: false,
      selectedObject: [],
      searchObj: {
        searchTxt: '',
        pageNo: 0,
        pageSize: 10,
        sortOrder: 'desc',
      },
      patientSearchInput: '',
      openAutoComplete: false,
      isVerifyingBin: false,
      isVerifyingBinMessage: '',
      doesPatientSelected: false,
      boxTypeId: '',
      brandPhone: '',
      brandName: '',
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      patientNotes: '',
      patientNotesReadOnly: true,
      selectedBinSize: '',
      isBinSizeRequired: false,
      isBinIdRequired: false,
      key: 0,
      isPatientSelectionDisabled: false,
      largeBinsCount: 0,
      mediumBinsCount: 0,
      smallBinsCount: 0,
      coolBinsCount: 0,
      makePreAssignmentAPICall: false,
      isPatientRecordNumberRequired: false,
      is_returnable: false,
      isManualOverridePermissionEnabled: false, 
      prescriptionUnAssign: false, 
      prescriptionAssign: false, 
      prescriptionView: false,
      prescriptionDirectPickup: false,
      prescriptionRemind: false,
      prescriptionConsult: false,
      prescriptionHoldResume: false,
      prescriptionAcDc: false,
      isOpenPath: false, 
    };
    this.textInput = React.createRef();
  }

  initSocket = async (authToken) => {
    if (!this.socket && this.user) {
      /**
       ** Socket Initialization **
       */

      this.socket = io(
        `${process.env.REACT_APP_VIDEO_SOCKET_BASEURL}/console-socket`,
        {
          transports: ['websocket'],
          auth: {
            token: `Bearer ${this.user.signInUserSession.idToken.jwtToken}`,
          },
          secure: true,
        }
      );

      /**
       ** Internal Socket Event **
       */

      this.socket &&
        this.socket.on('connect', () => {
          console.log('Socket connection established from PORTAL(ReConnect)');
        });
      this.socket &&
        this.socket.on('connect_error', (error) => {
          console.log('Connect Error: ', error);
          if (
            error.message === 'TokenExpiredError' ||
            error.message === 'JsonWebTokenError' ||
            error.message === 'NoTokenFound'
          ) {
            console.log('Token issue!');
          }
        });
      this.socket &&
        this.socket.on('connect_failed', (error) => {
          console.log('Connect Failed: ', error);
        });
      this.socket &&
        this.socket.on('error', (error) => {
          console.log('Error: ', error);
        });
      this.socket &&
        this.socket.on('disconnect', (reason) => {
          console.log(
            `Socket Disconnected From Portal and Reason is: ${reason}`
          );
        });
    }
  };

  componentWillUnmount() {
    this.socket && this.socket.disconnect();
    this.socket = false;
  }

  async componentDidMount() {
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.getBoxes(0);
    this.getSelectedUnitName(0);
    this.getFlageForPaymentRequired();
    let kioskId = 'a5bd2ad0-0780-42cd-a270-7e76c4f20500';
    this.getAllBoxes(kioskId);
    !this.socket && (await this.initSocket());
    this.is_pre_assignment = ['true', true].includes(sessionStorage.getItem('is_pre_assignment'));
    if (this.is_pre_assignment) {
      this.BinSizes = ['Medium', 'Small'];
    }
    this.setPermission();
  }

  getAllBoxes = async (id) => {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'getBoxesById/' + id, {
      method: 'get',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          this.setState({ loader: false });
          return null;
        }
      })
      .then((data) => {
        if (data && data.length > 0) {
          const boxId = this.state.box_id || data[0].id;
          const tmp = data.map((val) => {
            return {
              id: val.id,
              value: val.name,
              location_notes: val.location_notes,
              brandName: val.brandName,
              brandPhone: val.brandPhone,
              location_type_id: val.location_type_id,
              type_id: val.type_id,
              ...val,
            };
          });
          const obj = data.find((x) => x.id === boxId);
          this.getAssignedBins(boxId);
          this.getBoxesByID(boxId);
          this.getBoxes();
          this.setState({
            boxdata: tmp,
            box_id: boxId,
            ...(obj
              ? {
                boxTypeId: obj.type_id,
                prefer_location_name: obj.name,
                locationtype_id: obj.location_type_id,
                brandPhone: obj.brandPhone,
                brandName: obj.brandName
              }
              : {}),
            hasError: false,
            selectedBinId: '',
            isBoxSelected: true,
            loader: false,
          });
        } else {
          this.setState({ boxdata: [], loader: false });
        }
      });
  };

  //Naresh Start
  getFlageForPaymentRequired() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'getConnection', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((accountConnectionsId) => {
        if (
          accountConnectionsId !== null &&
          accountConnectionsId.length > 0 &&
          accountConnectionsId[0].is_payment_required !== ''
        ) {
          this.setState({
            isPaymentRequired: accountConnectionsId[0].is_payment_required,
            loader: false
          });
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  }

  textInputHandler = (type, value) => {
    this.setState({ [type]: value });
  };

  getCustomer(queryParam) {
    fetch(
      process.env.REACT_APP_BASEURL + 'Getcustomers?searchText=' + queryParam,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      }
    )
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        if (data) {
          const cuslist = data.map((cus) => {
            return { id: cus.id, name: cus.name + ' | ' + cus.dob_str };
          });
          this.setState({ customervalues: cuslist });
          this.setState({ customerList: data });
        }
      });
  }
  onPatientChange = (event) => {
    if (event.length > 3) {
      this.getCustomer(event);
    }
  };

  handleDialogClose = (event) => {
    this.setAutoCompleteOpen(false);
    this.setState({
      showDialog: false,
      popupDOB: null,
      popupphone: '',
      customervalues: [],
      openAutoComplete: false,
    });
    this.onOptionSelect(null, null, 'clear');
  };
  handleCoPayAmountDialogClose = (index, dataType, value) => {
    if (dataType === 'CoPayAmount') {
      dataType = 'price';
      let newState = this.state.scanRxItems.map((item, i) => {
        if (i === index) {
          return { ...item, [dataType]: value };
        }
        return item;
      });
      this.setState({
        scanRxItems: newState,
        CoPayAmountIndex: index,
        CoPayAmountValue: value,
      });
    } else {
      this.setState({ showCoPayAmountDialog: value });
    }
  };

  handleDialogValidate = async (event) => {
    const { t } = this.props;
    let isValidate = false;
    const pObj = this.state.customerList.find(
      (x) => x.id === this.state.selectedPatient.id
    );
    if (pObj && pObj.id) {
      let cusdob = pObj.dob_str
        ? moment(pObj.dob_str).format('YYYY-MM-DD')
        : null;
      let txtdob = this.state.popupDOB
        ? moment(this.state.popupDOB).format('YYYY-MM-DD')
        : null;
      let cusphone =
        pObj.contacts[0].phone !== '' && pObj.contacts[0].phone !== null
          ? pObj.contacts[0].phone
          : null;
      let txtphone =
        this.state.popupphone !== '' && this.state.popupphone !== undefined
          ? this.state.popupphone
          : null;
      let address1;
      let address2;
      let city;
      let state;
      let zip;
      let country;
      let locationtypesdata;
      let locationDetails =
        pObj.customerLocations.length > 0
          ? pObj.customerLocations.filter((x) => x.is_default_address === true)
          : pObj.customerLocations;
      if (locationDetails.length > 0) {
        locationtypesdata = locationDetails.map((type) => {
          // reuse label mapping but preserve existing extra properties like box_id
          const base = mapLocationTypesHelper([type], this.props.t)[0];
          return {
            ...type,
            id: base.id,
            label: base.label,
          };
        });
        this.setState({
          locationtype: locationtypesdata,
          locationtype_id: locationtypesdata[0].id,
          box_id: locationtypesdata[0].box_id,
        });
        if (locationtypesdata[0].id === LOCATION_TYPE.Kiosk) {
          const item = this.state.boxTypes.find((item) =>
            [this.state.box_id, locationtypesdata[0].box_id].includes(item.id)
          );
          if (item) {
            address1 = item.address.address_line_1;
            address2 = item.address.address_line_2;
            city = item.address.city;
            state = item.address.state;
            zip = item.address.zip;
            country = item.address.country;
          }
        } else {
          const type = locationtypesdata[0];
          address1 = type.addressline1;
          address2 = type.addressline2;
          city = type.city;
          state = type.state;
          zip = type.zip;
          country = type.country;
        }
      } else {
        if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
          const locationtypesdata = [
            {
              id: this.state.locationtype_id,
              label: this.props.t('API.LocationType.Kiosk'),
              box_id: this.state.box_id,
            },
          ];
          this.setState({ locationtype: locationtypesdata });
          const item = this.state.boxTypes.forEach(
            (item) => this.state.box_id === item.id
          );
          if (item) {
            address1 = item.address.address_line_1;
            address2 = item.address.address_line_2;
            city = item.address.city;
            state = item.address.state;
            zip = item.address.zip;
            country = item.address.country;
          }
        }
      }
      if (
        cusdob === txtdob &&
        this.ReplacePhone(cusphone).replaceAll('-', '') ===
        this.ReplacePhone(txtphone).replaceAll('-', '')
      ) {
        isValidate = true;
        let boxId =
          locationtypesdata[0].box_id || pObj.customerLocations[0].box_id;
        this.setState({
          phone: pObj.contacts[0].phone,
          EmailID: pObj.contacts[0].email,
          box_id: boxId,
          searchedItems: {
            FirstName: pObj.first_name,
            LastName: pObj.last_name,
            DateOfBirth: pObj.dob_str,
            MobileNo: pObj.contacts[0].phone,
            EmailID: pObj.contacts[0].email,
            PatientID: pObj.patient_id,
            AddressLine1: address1,
            AddressLine2: address2,
            City: city,
            State: state,
            Zip: zip,
            Country: country,
            notes: pObj.notes,
            location_notes: pObj.customerLocations[0].location_notes,
            order_notes: pObj.customerLocations[0].patient_notes,
          },
          customervalues: [],
          openAutoComplete: false,
          patientNotes: this.validateFields(pObj && pObj.notes),
          patientNotesReadOnly: false,
        });
      }
      await this.handletypeChange(locationtypesdata[0].id);
      await this.handleChange(locationtypesdata[0].box_id);
    }

    if (!isValidate) {
      toast.error(t("Assign.DoesNotMatch"));
    } else {
      const DefaultCartItem = {
        id: '-1',
        rxNo: '',
        drugname: '',
        ndcCode: '',
        price: '0.00',
        CoPayAmount: '0.00',
        qty: 0,
        ConsultRequire: false,
      };
      this.setState({
        showDialog: false,
        popupDOB: null,
        popupphone: '',
        scanRxItems: [DefaultCartItem],
        customervalues: [],
        openAutoComplete: false,
      });
      if (![undefined, 'undefined', null, 'null', ''].includes(pObj)) {
        if (![undefined, 'undefined', null, 'null', ''].includes(pObj.patient_id)) {
          this.checkADACompatible(pObj.patient_id, pObj.contacts[0].email, pObj.contacts[0].phone);
        }
      }
      this.generateCodes();
      const focusOnRxField = document.getElementById('rxNo');
      focusOnRxField && focusOnRxField.focus();
    }
  };

  checkADACompatible = (PatientID, EmailID, phone) => {
    let patientObj = {
      PatientID: PatientID,
      EmailID: EmailID,
    };
    fetch(process.env.REACT_APP_BASEURL + 'getADACompatiblePatients', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(patientObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((Pdata) => {
        if (Pdata && Pdata.ADAcustomers && Pdata.ADAcustomers.length > 0) {
          this.setState({ ADAData: Pdata.ADAcustomers, isADACompatible: true });
        } else {
          this.setState({ ADAData: [], isADACompatible: false, loader: false });
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };
  ReplacePhone = (phone) => {
    let newphone = '';
    if (phone.length > 0) {
      newphone = phone
        .replace('(', '')
        .replace(')', '')
        .replace(' ', '')
        .replace('-', '');
    }
    return newphone;
  };
  handlePhoneChange = (event) => {
    this.setState({ popupphone: event.target.value });
  };
  onDateSelect = (date) => {
    date = date ? moment(date).format() : '';
    this.setState({ popupDOB: date });
  };
  handleBlurdob = (e) => {
    let date = null;
    date =
      e.target.value && e.target.value !== ''
        ? moment(e.target.value).format()
        : null;
    this.setState({
      popupDOB: date,
    });
  };

  onRXValidate = (index, dataType, value) => {
    if (['', null, undefined].includes(value)) return true;

    if (index !== 0) {
      let isValid = this.checkExistRxNo(value, index);
      if (isValid > 0) {
        toast.error(this.props.t('Toast.Error.RxAddedToCart'));
      }
    }
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'checkrxexistornot/' + value + '/false' , {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((boxes) => {
        if (boxes && !boxes.Rx_Is_Exist) {
          let newState = this.state.scanRxItems.map((item, i) => {
            if (i === index) {
              this.state.rxDetails.filter((element) => {
                return element.orders.some((order) => {
                  return order.items.some((items) => {
                    const trulyValue =
                      items.rxNo.toString().toUpperCase() ===
                      value.toString().toUpperCase();
                    return trulyValue;
                  })
                })
              });
              return { ...item, [dataType]: value };
            }
            return item;
          });

          if (this.state.isPaymentRequired === true) {
            this.setState({
              showCoPayAmountDialog: true,
              CoPayAmountIndex: index,
              CoPayAmountValue: '0.00',
            });
          }
          const scanrxIndex = newState.findIndex((x) => x.rxNo === '');
          if (scanrxIndex > -1) {
          } else {
            const DefaultCartItem = {
              id: '-1',
              rxNo: '',
              drugname: '',
              ndcCode: '',
              price: '0.00',
              CoPayAmount: '0.00',
              qty: 0,
              ConsultRequire: false,
            };
            newState.push(DefaultCartItem);
          }
          this.setState({
            scanRxItems: newState,
            loader: false
          });
          const elements = document.querySelectorAll('#drugname');
          elements.length && elements[elements.length - 2].focus();
        } else {
          this.setState({ rxNumber: '', loader: false });
          toast.error(this.props.t('Toast.Error.RxAssigned'));
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  onScanRxChange = (index, dataType, value) => {
    if (dataType === 'rxNo') {
      if (value.toString().toUpperCase().length > 0) {
        const searchedString = value;
        this.setState({ rxNumber: searchedString && searchedString });
        let scanRxItems = this.state.scanRxItems.map((item, i) => {
          if (i === index) return { ...item, [dataType]: value };
          return item;
        });
        this.setState({ scanRxItems });
        if (searchedString.length === 20) {
          let { scanRxItems, accountDetails } = this.state;
          const rxNo = searchedString.substring(0, 8);
          const taxablePriceStr = searchedString.substring(8, 14);
          const nonTaxablePriceStr = searchedString.substring(14);
          const taxablePrice = Number(taxablePriceStr) / 100;
          const nonTaxablePrice = Number(nonTaxablePriceStr) / 100;
          let totalPrice = nonTaxablePrice;
          const taxRate = accountDetails && accountDetails.tax_data.tax_rate;
          if (accountDetails && accountDetails.is_taxable) {
            totalPrice = taxablePrice + nonTaxablePrice + taxablePrice * Number(taxRate)
          }
          scanRxItems = scanRxItems.map((item, index) => {
            if (index === scanRxItems.length - 1) {
              item.rxNo = rxNo
              item.price = totalPrice.toString()
              return item
            }
            return item
          })
          this.setState({ scanRxItems })
          setTimeout(() => {
            const elements = document.querySelectorAll('#drugname');
            elements.length && elements[elements.length - 1].focus();
          }, 10);
        }
      } else {
        let scanRxItems = this.state.scanRxItems.map((item, i) => {
          if (i === index) {
            return { ...item, [dataType]: value };
          }
          return item;
        });
        this.setState({ scanRxItems });
      }
    } else {
      let newState = this.state.scanRxItems.map((item, i) => {
        if (i === index) {
          return { ...item, [dataType]: value };
        }
        return item;
      });
      this.setState({
        scanRxItems: newState,
      });
    }
  };

  checkExistRxNo = (rxno, idx) => {
    let RxNo = this.state.scanRxItems
      .filter((_, index) => index !== idx)
      .filter((item) => {
        if (item.rxNo !== '') {
          const trulyValue =
            item.rxNo.toString().toLowerCase() ===
            rxno.toString().toLowerCase();
          if (!trulyValue) {
            return false;
          }
          return trulyValue;
        }
        return true;
      });
    return RxNo.length;
  };

  getBoxesByID = (id) => {
    this.setState({ loader: true });
    fetch(`${process.env.REACT_APP_BASEURL}boxes/${id}`, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((boxes) => {
        if (boxes.length > 0) {
          this.setState(
            {
              courier_type:
                boxes[0].courier_type && boxes[0].courier_type.length > 0
                  ? boxes[0].courier_type.map((val) => {
                    return val.courier_type;
                  })
                  : [],
            },
            () => {
              if (this.state.courier_type.length > 0) {
                this.setState({
                  default_courier_selected:
                    boxes[0].courier_type[0].default_courier_type,
                });
              }
            }
          );
          let search = this.state.searchedItems;
          if (search) {
            search.location_notes = '';
            search.location_notes = boxes[0].location_notes;
            this.setState({ searchedItems: search, loader: false });
          }
          if (this.is_pre_assignment && boxes[0].type_id === BOX_TYPE.Locker && !this.BinSizes.includes('Large')) {
            this.BinSizes.unshift('Large')
          }
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };
  //Naresh End
  getBoxes(value) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'boxes', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((boxtypes) => {
        if (boxtypes) {
          const tmp = boxtypes.map((val) => {
            return {
              id: val.id,
              value: val.name,
              location_notes: val.location_notes,
              brandName: val.brandName,
              brandPhone: val.brandPhone,
              location_type_id: val.location_type_id,
              type_id: val.type_id,
              ...val,
            };
          });
          if (boxtypes.length > 0) {
            if (value === 0) {
              const defaultSelectedBoxId = tmp[0].id;
              if (this.state.box_id === null) {
                this.setState({ box_id: tmp[0].id });
                this.getAssignedBins(defaultSelectedBoxId);
              }
              this.getPharmacyDetails(defaultSelectedBoxId);
              this.getExpansionBins(defaultSelectedBoxId);
              if (this.is_pre_assignment) {
                this.getAvailableBinsCount(defaultSelectedBoxId);
              }
            } else {
              this.getAssignedBins(this.state && this.state.box_id);
              this.getPharmacyDetails(this.state && this.state.box_id);
              this.getExpansionBins(this.state && this.state.box_id);
              if (this.is_pre_assignment) {
                this.getAvailableBinsCount(this.state && this.state.box_id);
              }
            }
          }
          // Do NOT set boxdata here: GET /boxes does not return brandName/brandPhone.
          // boxdata must come from getAllBoxes (getBoxesById) which includes brand info for labels.
          this.setState({ boxTypes: tmp, loader: false, isOpenPath: tmp && tmp.openpath });
        } else {
          this.setState({ loader: false });
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'locationtypes', {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((locationtypes) => {
        if (locationtypes) {
          const locationtypesdata = [];
          let newLocationtypes = [
            ...new Set(locationtypes && locationtypes.map((obj) => obj.name)),
          ].map((name) => {
            return (
              locationtypes && locationtypes.find((obj) => obj.name === name)
            );
          });
          for (let i = 0; i < newLocationtypes.length; i++) {
            if (
              newLocationtypes[i].id !==
              '5e94cb81-ab9b-4e82-8b98-721a2d1794df' &&
              newLocationtypes[i].id !==
              'fd7c6330-8b9a-45e2-a1f6-f791db65f5d0' &&
              newLocationtypes[i].id !== 'ee98b36c-a0e9-4cc4-a411-6c925ad442b6'
            ) {
              let tmp = {};
              tmp = {
                id: newLocationtypes[i].id,
                label: this.props.t(newLocationtypes[i].name_es),
              };
              locationtypesdata.push(tmp);
            }
          }
          if (!this.state.locationtype_id) {
            this.setState({ locationtype_id: locationtypesdata.length > 0 ? locationtypesdata[0].id : [], loader: false });
          }
          this.setState({ locationtype: locationtypesdata, loader: false });
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  }

  generateCodes() {
    const _stockCode = [true, "true"].includes(this.state.isOpenPath) || JSON.parse(localStorage.getItem("isNumericCode"))
      ? randomized("0", 4)
      : randomized("A0", 6, { exclude: "0oOiIlL1&zZ" });
    const _pickupCode = [true, "true"].includes(this.state.isOpenPath) || JSON.parse(localStorage.getItem("isNumericCode"))
      ? randomized("0", 4)
      : randomized("A0", 6, { exclude: "0oOiIlL1&zZ" });
    setTimeout(() => {
      this.checkIfCodesExists({
        stockCode: _stockCode,
        pickupCode: _pickupCode,
      });
    }, 3500);
  }

  getSelectedBin = (binId, position, flag) => {
    this.setState({
      selectedBinId: binId,
      box_position: position,
      isSelectedFlag: flag,
      isBinIdRequired: false
    });
  };
  /*
      Added By : Belani Jaimin
      Added Date : 02/11/2019
      Description : Get Bin Status
    */
  getAssignedBins = (box_id) => {
    let _binStatus = [];
    this.setState({ loader: true });
    if (!this.is_pre_assignment) {
      fetch(process.env.REACT_APP_BASEURL + 'api/v2/orders/occupied-bins/' + box_id, {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((bins) => {
          let deactivatedBins;
          _binStatus = JSON.parse(bins);
          if (_binStatus && _binStatus[0] && _binStatus[0].disabled_bins) {
            deactivatedBins = _binStatus[0].disabled_bins.toString().split(',');
            this.setState({ deactivatedBins: deactivatedBins, loader: false });
          } else {
            this.setState({ deactivatedBins: [], loader: false });
          }
          this.setState({ BinStatus: _binStatus, loader: false });
        }).catch(() => {
          this.setState({ loader: false });
        });
    }
  };

  handleChange = async (value) => {
    const boxtype =
      this.state &&
      this.state.boxdata &&
      this.state.boxdata.length > 0 &&
      this.state.boxdata.find((x) => x.id === value);
    boxtype &&
      this.setState({
        boxTypeId: boxtype.type_id,
        prefer_location_name: boxtype.value,
        box_id: value,
      });

    if (this.state.locationtype_id !== LOCATION_TYPE.Kiosk) return;
    if (this.is_pre_assignment) {
      this.BinSizes = ['Medium', 'Small'];
    }
    this.getBoxesByID(value);
    this.getPharmacyDetails(value);
    this.getExpansionBins(value);

    if (this.state.selectedBinId !== '') {
      let items = document.getElementById(this.state.selectedBinId);
      items.style.removeProperty('background');
    }

    this.setState({ hasError: false, selectedBinId: '', isBoxSelected: true });
    this.getAssignedBins(value);
    this.getBoxes();
    if (this.is_pre_assignment) {
      this.getAvailableBinsCount(value);
    }
    setTimeout(() => {
      const elements = document.querySelectorAll('#rxNo');
      elements.length && elements[elements.length - 1].focus();
    }, 10);
  };

  handletypeChange = async (value) => {
    let orders =
      this.state && this.state.searchedItems && this.state.searchedItems.orders;
    const locationDetails = this.state.locationDetails;
    const basicDetails = this.state.basicDetails;
    const contactDetails = this.state.contactDetails;

    await this.getAllBoxes(value);

    let address1;
    let address2;
    let city;
    let state;
    let zip;
    let country;
    // eslint-disable-next-line
    let location_notes;
    if (locationDetails && locationDetails.length > 0) {
      if (value === LOCATION_TYPE.Kiosk) {
        const boxData = this.state.boxdata;
        boxData.forEach((item) => {
          if (this.state.box_id === item.id) {
            address1 = item.address.address_line_1;
            address2 = item.address.address_line_2;
            city = item.address.city;
            state = item.address.state;
            zip = item.address.zip;
            country = item.address.country;
            location_notes = item.address.location_notes;
          }
        });
      } else {
        locationDetails.forEach((type) => {
          if (value === type.locationtype_id) {
            address1 = type.addressline1;
            address2 = type.addressline2;
            city = type.city;
            state = type.state;
            zip = type.zip;
            country = type.country;
            location_notes = type.location_notes;
          }
        });
      }
      this.setState({
        loader: true,
        locationtype_id: value,
        EmailID: contactDetails && contactDetails.email,
        phone: contactDetails && contactDetails.phone,
        searchedItems: {
          FirstName: basicDetails && basicDetails.first_name,
          LastName: basicDetails && basicDetails.last_name,
          DateOfBirth: basicDetails && basicDetails.dob_str,
          MobileNo: contactDetails && contactDetails.phone,
          EmailID: contactDetails && contactDetails.email,
          AddressLine1: address1,
          AddressLine2: address2,
          City: city,
          State: state,
          Zip: zip,
          Country: country,
          orders: orders,
          location_notes: '',
          notes: basicDetails && basicDetails.notes
        },
        patientNotes: this.validateFields(basicDetails && basicDetails.notes)
      });
    }
  };
  getPharmacyDetails(boxId) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'boxes/' + boxId, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((phrmacydetail) => {
        if (phrmacydetail && phrmacydetail[0]) {
          this.setState({ pharmacyDetails: phrmacydetail[0], loader: false });
          const accountId = phrmacydetail[0].parent_account_id;
          this.getAccountDetails(accountId);
          if (this.is_pre_assignment && phrmacydetail[0].type_id === BOX_TYPE.Locker && !this.BinSizes.includes('Large')) {
            this.BinSizes.unshift('Large')
          }
        } else {
          this.setState({ loader: false });
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  }
  //Added by Naresh | DI-329 | Date:27-05-2019
  getExpansionBins(boxId) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'box-expansions/' + boxId, {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((expansionDetails) => {
        let order = 0;
        let UnitLayout = [];
        let UnitIndex = 0;
        if (expansionDetails && expansionDetails.length > 0) {
          //Add Left side Unit
          UnitLayout = [];
          if (expansionDetails.findIndex((x) => x.direction === 1) > -1) {
            expansionDetails &&
              expansionDetails.map((unit, index) => {
                let boxlist = [];
                if (unit.direction === 1) {
                  boxlist = unit;
                  boxlist.order = order + 1;
                  boxlist.selectedUnitIndex = Math.abs(unit.box_position);
                  boxlist.pos = 'L';
                  boxlist.box_position = unit.box_position;
                  order = order + 1;
                  UnitLayout.push(boxlist);
                  UnitIndex = UnitIndex + 1;
                }
                if (this.is_pre_assignment) {
                  if (unit.expansion_id === BOX_TYPE.Cool && !this.BinSizes.includes('Cool')) {
                    this.BinSizes.push('Cool');
                  }
                  if (unit.expansion_id === BOX_TYPE.L60 && !this.BinSizes.includes('Large')) {
                    this.BinSizes.unshift('Large');
                  }
                }
                return true;
              });
          }
          if (UnitLayout.length > 0) {
            UnitLayout.reverse();
          }
          order = order + 1;
          //UnitLayout.push({ id: -1, order: order, pos: 'M', selectedUnitIndex: 0, box_position: 0 });
          UnitIndex = UnitIndex + 1;
          const unitExpansions = {
            id: -1,
            order: order,
            pos: 'M',
            selectedUnitIndex: 0,
            box_position: 0,
          };
          const boxesExpansions =
            expansionDetails &&
            expansionDetails.find((x) => x.box.id === boxId);
          if (boxesExpansions && boxesExpansions !== undefined) {
            if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.Locker
            ) {
              if (this.is_pre_assignment && !this.BinSizes.includes('Large')) {
                this.BinSizes.unshift('Large')
              }
              UnitLayout.push(unitExpansions);
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.M22
            ) {
              unitExpansions.pos = 'M22';
              UnitLayout.push(unitExpansions);
            } else if (
              boxesExpansions &&
              boxesExpansions.box &&
              boxesExpansions.box !== '' &&
              boxesExpansions.box !== null &&
              boxesExpansions.box !== undefined &&
              boxesExpansions.box.type_id === BOX_TYPE.M24
            ) {
              unitExpansions.pos = 'M24';
              UnitLayout.push(unitExpansions);
            } else {
              UnitLayout.push(unitExpansions);
            }
          }

          //Add Right side Unit
          if (expansionDetails.findIndex((x) => x.direction === 2) > -1) {
            expansionDetails &&
              expansionDetails.map((unit, index) => {
                let boxlist = [];
                if (unit.direction === 2) {
                  boxlist = unit;
                  boxlist.order = order + 1;
                  boxlist.selectedUnitIndex = unit.box_position;
                  boxlist.pos = 'R';
                  boxlist.box_position = unit.box_position;
                  order = order + 1;
                  UnitLayout.push(boxlist);
                  UnitIndex = UnitIndex + 1;
                }
                if (this.is_pre_assignment) {
                  if (unit.expansion_id === BOX_TYPE.Cool && !this.BinSizes.includes('Cool')) {
                    this.BinSizes.push('Cool');
                  }
                  if (unit.expansion_id === BOX_TYPE.L60 && !this.BinSizes.includes('Large')) {
                    this.BinSizes.unshift('Large');
                  }
                }
                return true;
              });
          }
        } else {
          order = order + 1;
          //UnitLayout.push({ id: -1, order: order, pos: 'M', selectedUnitIndex: 0, box_position: 0 });
          const unitExpansions = {
            id: -1,
            order: order,
            pos: 'M',
            selectedUnitIndex: 0,
            box_position: 0,
          };
          const boxes =
            this.state &&
            this.state.boxdata &&
            this.state.boxdata.length &&
            this.state.boxdata.length > 0 &&
            this.state.boxdata.find((x) => x.id === boxId);
          if (boxes && boxes !== undefined) {
            if (
              boxes &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.Locker
            ) {
              UnitLayout.push(unitExpansions);
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.M22
            ) {
              unitExpansions.pos = 'M22';
              UnitLayout.push(unitExpansions);
            } else if (
              boxes &&
              boxes.type &&
              boxes.type_id !== '' &&
              boxes.type_id !== null &&
              boxes.type_id !== undefined &&
              boxes.type_id === BOX_TYPE.M24
            ) {
              unitExpansions.pos = 'M24';
              UnitLayout.push(unitExpansions);
            } else {
              UnitLayout.push(unitExpansions);
            }
          }
        }
        this.setState({ expansionUnits: UnitLayout, loader: false });
      }).catch(() => {
        this.setState({ loader: false });
      });
  }
  //End DI-329
  getAccountDetails(accountId) {
    this.setState({ loader: true });
    fetch(
      process.env.REACT_APP_BASEURL + 'account/' + accountId,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
      },
      accountId
    )
      .then((response) => response.json())
      .then((accountdetail) =>
        this.setState({ accountDetails: accountdetail && accountdetail[0], loader: false })
      ).catch(() => {
        this.setState({ loader: false });
      });
  }
  EventLogHanlder = (uData) => {
    let tofor_id = '';
    let descriptions = '';
    tofor_id =
      uData && uData.prescriptions_master && uData.prescriptions_master.id;
    descriptions =
      'Prescription is Assigned with stock code ' +
      this.state.stockCode +
      ' and pick up code ' +
      this.state.pickupCode +
      ' with Rx No ' +
      this.state.rxNumber;

    let event_name = '';
    let event_type_name = '';
    if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
      event_name = EVENT_CRUD_TYPES.INSERT;
      event_type_name = EVENT_TYPES.ASSIGNED;
    } else {
      event_name = EVENT_CRUD_TYPES.INSERT;
      event_type_name = EVENT_TYPES.Ready;
    }

    const event_params = {
      event_name: event_name,
      event_type_name: event_type_name,
      description: descriptions,
      object_id: assignmentstatus.ASSIGNED,
      tofor_id: tofor_id,
      box_id: this.state.box_id,
    };
    new EventLogHandler().handleEventLog(event_params);
  };

  ReplaceAmount = (Amount) => {
    let reN = /[$,]/g;
    Amount = Amount.toString().replace(reN, '');
    return Amount;
  };

  getCartRxNumbers = () => {
    searchedRxNumbers = [];
    this.state.scanRxItems.map((item) => {
      if (item && item.rxNo !== '') {
        searchedRxNumbers.push(item.rxNo || item.rx_no);
      }
      return true;
    });
  };

  openAllBin() {
    let Ids = [];
    nums1.forEach((n1) => {
      nums.forEach((n) => {
        if ((elem[n] === 'B' || elem[n] === 'C') && n1 >= 0 && n1 <= 6) {
        } else {
          if (elem[n] === 'A') {
            Ids.push(elem[n] + '' + (n1 + 1));
          } else if (elem[n] === 'B' && n1 >= 7 && n1 <= 11) {
            Ids.push(elem[n] + '' + (n1 + 1));
          } else if (elem[n] === 'C' && n1 >= 7 && n1 <= 11) {
            Ids.push(elem[n] + '' + (n1 + 1));
          } else {
            Ids.push(elem[n] + '' + (n1 + 1));
          }
        }
      });
    });

    const filteredArray = this.sortArray(Ids);
    for (let index = 0; index < filteredArray.length; index++) {
      const element = filteredArray[index];
      let items = document.getElementById(element);
      items.style.background =
        'linear-gradient(148deg, #ffffff 30%, #d9dcdb 60%, #dcdcdc 87%)';
      items.style.color = '#000';
    }
  }

  sortArray(Ids) {
    let reA = /[^a-zA-Z]/g;
    let reN = /[^0-9]/g;

    function sortAlphaNum(a, b) {
      let aA = a.replace(reA, '');
      let bA = b.replace(reA, '');
      if (aA === bA) {
        let aN = parseInt(a.replace(reN, ''), 10);
        let bN = parseInt(b.replace(reN, ''), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    }
    return Ids.sort(sortAlphaNum);
  }

  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      this.setState({
        selected: this.state.scanRxItems.map((n) => n.rxNo),
      });
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id, index) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  confirmDelete = (event) => {
    this.setState({
      deleteDialogOpen: true,
      forDeletion:
        this.state &&
        this.state.scanRxItems.filter(
          (x) => this.state.selected.indexOf(x.rxNo) > -1
        ),
    });
  };

  deleteConfirmClose = (event) => {
    this.setState({
      deleteDialogOpen: false,
      selectedRowId: null,
      forDeletion: null,
    });
  };

  deleteConfirmed = (event) => {
    this.deleteItems();
    this.setState({ deleteDialogOpen: false });
  };

  deleteItems = (event) => {
    const rowIdToDelete = this.state.forDeletion;
    if (rowIdToDelete.length === this.state.scanRxItems.length) {
      const DefaultCartItem = {
        id: '-1',
        rxNo: '',
        drugname: '',
        ndcCode: '',
        price: '0.00',
        CoPayAmount: '0.00',
        qty: 0,
        ConsultRequire: false,
      };
      this.setState({
        searchedRxNo: [],
        // searchedItems: [],
        rxNumber: '',
        selected: [],
        scanRxItems: [DefaultCartItem],
      });

      this.openAllBin();
    } else {
      let newFilterDelete = [];
      for (let i = 0; i < rowIdToDelete.length; i++) {
        newFilterDelete = this.state.scanRxItems.filter(
          // eslint-disable-next-line no-loop-func
          (x) => x.rxNo !== rowIdToDelete[i].rxNo
        );
      }
      this.setState({
        rxNumber: '',
        selected: [],
        scanRxItems: newFilterDelete,
      });
    }
  };

  getPrescriptionDetails = (BinId, pm_id) => {
    const { accountDetails, scanRxItems } = this.state;
    const { t } = this.props;
    this.setState({ isEdit: true, binid: BinId, pmid: pm_id, indexNo: '' });
    if (
      scanRxItems &&
      scanRxItems.length > 0 &&
      this.state &&
      this.state.doesPatientSelected
    ) {
      let obj = {
        bin_id: BinId,
        box_id: this.state && this.state.box_id,
        account_id: accountDetails && accountDetails.id,
      };
      this.setState({ loader: true });
      fetch(process.env.REACT_APP_BASEURL + 'prescription/status/check', {
        crossDomain: true,
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(obj),
      })
        .then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          if (res && res.statusCode === 409) {
            this.setState({
              isVerifyingBin: true,
              isVerifyingBinMessage: t("Assign.BinNotAvailable"),
              loader: false,
            });
          }
        });
    } else {
      /**
       * Pre-assignment (Canada unplugged) flow:
       * When clicking a Recent Order row we always have a valid pm_id, and we
       * want to hydrate the Deliver Prescription screen from that PM record.
       * Previously this block only ran when BinId === null, which meant that
       * clicks where a bin was already assigned (BinId !== null) populated the
       * patient header but never loaded the prescription items grid.
       *
       * To fix that with minimal impact on legacy flows, we now:
       * - For pre-assignment accounts: always fetch by pm_id via rxbyPMID,
       *   regardless of whether BinId is null or not.
       * - For non pre-assignment accounts: retain the existing behaviour.
       */
      if (this.is_pre_assignment) {
        const boxId = this.state.box_id;
        this.getPharmacyDetails(boxId);
        const bin_info = {
          id: boxId,
          pm_id: pm_id,
        };
        this.setState({ loader: true, reminderData: [] });
        fetch(process.env.REACT_APP_BASEURL + 'pre-assignment/rxbyPMID', {
          method: 'POST',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(bin_info),
        })
          .then((response) => {
            try {
              return response.json();
            } catch (error) {
              return null;
            }
          })
          .then((data) => {
            if (data) {
              this.setState({
                reminderData: { bin_info: bin_info, data: data },
                isVisibleForPause: true,
              });
              const details = data.response.box;
              if (details && details.customers.length > 0) {
                const basicDetails = details && details.customers[0];
                const orders = details && details.customers[0].orders[0];
                const typeId = orders.type_id;
                const stockcode = orders.stock_code;
                const pickupcode = orders.pucode;
                const rxItems = orders.items;
                const orderId = details && details.customers[0].orders[0].id;
                const rxNo =
                  details && details.customers[0].orders[0].items[0].rx_no;
                const bindId = details && details.customers[0].orders[0].bin_id;
                const binSize = orders && orders.bin_size;
                const contactDetails =
                  details && details.customers[0].contacts[0];
                const locationDetails = orders && orders.customerLocations;
                // Codes stored in state only - fetched fresh from database before printing
                this.setState({
                  stockCode: orders.stock_code,
                  pickupCode: orders.pucode,
                  locationDetails: locationDetails,
                  basicDetails: basicDetails,
                  contactDetails: contactDetails,
                  PrintisCoolItem: orders['is_cool_item'],
                  EmailID: contactDetails.email,
                  phone: contactDetails.phone,
                });
                let address1;
                let address2;
                let city;
                let state;
                let zip;
                let country;
                let location_notes;
                if (locationDetails.length > 0) {
                  const locationtypesdata = mapLocationTypesHelper(locationDetails, this.props.t);
                  this.setState({
                    locationtype: locationtypesdata,
                    locationtype_id: locationtypesdata[0].id,
                  });
                  if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
                    const boxData = this.state.boxdata;
                    boxData.forEach((item) => {
                      if (this.state.box_id === item.id && item && item.address) {
                        address1 = item.address.address_line_1 || '';
                        address2 = item.address.address_line_2 || '';
                        city = item.address.city || '';
                        state = item.address.state || '';
                        zip = item.address.zip || '';
                        country = item.address.country || '';
                        location_notes = item.address.location_notes || '';
                      }
                    });
                  } else {
                    locationDetails.forEach((type) => {
                      if (this.state.locationtype_id === type.locationtype_id) {
                        address1 = type.addressline1;
                        address2 = type.addressline2;
                        city = type.city;
                        state = type.state;
                        zip = type.zip;
                        country = type.country;
                        location_notes = type.location_notes;
                      }
                    });
                  }
                } else {
                  if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
                    const locationtypesdata = [
                      { id: this.state.locationtype_id, label: this.props.t('API.LocationType.Kiosk') },
                    ];
                    this.setState({ locationtype: locationtypesdata });
                    const boxData = this.state.boxdata;
                    boxData.forEach((item) => {
                      if (this.state.box_id === item.id && item && item.address) {
                        address1 = item.address.address_line_1 || '';
                        address2 = item.address.address_line_2 || '';
                        city = item.address.city || '';
                        state = item.address.state || '';
                        zip = item.address.zip || '';
                        country = item.address.country || '';
                        location_notes = item.address.location_notes || '';
                      }
                    });
                  }
                }
                if (typeId === DEVICE_TYPE.Hold) {
                  this.setState({ isAlreadyOnHold: true });
                } else {
                  this.setState({ isAlreadyOnHold: false });
                }
                if (typeId === DEVICE_TYPE.Assigned) {
                  this.setState({ isAlreadyAssigned: true });
                } else {
                  this.setState({ isAlreadyAssigned: false });
                }
                if (typeId === DEVICE_TYPE.Stocked) {
                  this.setState({ is_stocked: true });
                } else {
                  this.setState({ is_stocked: false });
                }
                let Patient = [];
                Patient.push({ id: basicDetails.id, name: basicDetails.name });
                let Arraycart = [];
                for (let i = 0; i < rxItems.length; i++) {
                  let item = {};
                  item.id = i;
                  item.rxNo = rxItems[i].rx_no;
                  item.drugname = rxItems[i].drug_name;
                  item.ndcCode = rxItems[i].ndc_code;
                  item.price = rxItems[i].price;
                  item.qty = rxItems[i].qty;
                  item.ConsultRequire = rxItems[i].is_consultrequire;
                  item.orderid = rxItems[i].id;
                  item.is_order_released = rxItems[i].is_order_released;
                  Arraycart.push(item);
                }
                this.setState({
                  isPatientSelectionDisabled: true,
                  searchedItems: {
                    FirstName: basicDetails.first_name,
                    LastName: basicDetails.last_name,
                    DateOfBirth: basicDetails.dob_str,
                    MobileNo: this.state && this.state.phone,
                    EmailID: this.state && this.state.EmailID,
                    AddressLine1: address1,
                    AddressLine2: address2,
                    City: city,
                    State: state,
                    Zip: zip,
                    Country: country,
                    location_notes: location_notes,
                    isCoolItem: orders && orders.is_cool_item,
                  },
                  rxNumber: rxNo,
                  selectedBinId: bindId,
                  selectedBinSize: binSize ? binSize : '',
                  isBinSizeRequired: false,
                  isBinIdRequired: false,
                  stockCode: stockcode,
                  pickupCode: pickupcode,
                  orderId: orderId,
                  selectedPatient: Patient[0],
                  readOnly: true,
                  scanRxItems: Arraycart,
                  isPatientRecordNumberRequired: false,
                });
                this.getPaymentDetails(orderId, basicDetails.id);
              }
              this.getCartRxNumbers();
              this.setState({ assignedPrescription: data.response.box });
              this.forceUpdate();
            } else {
              const DefaultCartItem = {
                id: '-1',
                rxNo: '',
                drugname: '',
                ndcCode: '',
                price: '0.00',
                CoPayAmount: '0.00',
                qty: 0,
                ConsultRequire: false,
              };
              this.setState({
                searchedRxNo: [],
                searchedItems: [],
                rxNumber: '',
                selected: [],
                scanRxItems: [DefaultCartItem],
              });
            }
          });
        } else {
          const boxId = this.state.box_id;
          this.getPharmacyDetails(boxId);
          const bin_info = {
            id: boxId,
            bin_id: BinId,
            pm_id: pm_id,
          };
          this.setState({ loader: true, reminderData: [] });
          fetch(process.env.REACT_APP_BASEURL + 'rxbybin', {
          method: 'POST',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(bin_info),
        })
          .then((response) => {
            try {
              return response.json();
            } catch (error) {
              return null;
            }
          })
          .then((data) => {
            if (data) {
              this.setState({
                reminderData: { bin_info: bin_info, data: data },
                isVisibleForPause: true,
              });
              const details = data.response.box;
              if (details && details.customers.length > 0) {
                const basicDetails = details && details.customers[0];
                const orders = details && details.customers[0].orders[0];
                const typeId = orders.type_id;
                const stockcode = orders.stock_code;
                const pickupcode = orders.pucode;
                const rxItems = orders.items;
                const orderId = details && details.customers[0].orders[0].id;
                const rxNo =
                  details && details.customers[0].orders[0].items[0].rx_no;
                const bindId = details && details.customers[0].orders[0].bin_id;
                const binSize = orders && orders.bin_size;
                const contactDetails =
                  details && details.customers[0].contacts[0];
                const locationDetails = orders && orders.customerLocations;
                // Codes stored in state only - fetched fresh from database before printing
                this.setState({
                  stockCode: orders.stock_code,
                  pickupCode: orders.pucode,
                  locationDetails: locationDetails,
                  basicDetails: basicDetails,
                  contactDetails: contactDetails,
                  PrintisCoolItem: orders['is_cool_item'],
                  EmailID: contactDetails.email,
                  phone: contactDetails.phone,
                });
                let address1;
                let address2;
                let city;
                let state;
                let zip;
                let country;
                let location_notes;
                if (locationDetails.length > 0) {
                  const locationtypesdata = mapLocationTypesHelper(locationDetails, this.props.t);
                  this.setState({
                    locationtype: locationtypesdata,
                    locationtype_id: locationtypesdata[0].id,
                  });
                if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
                  const boxData = this.state.boxdata;
                  boxData.forEach((item) => {
                    if (this.state.box_id === item.id && item && item.address) {
                      address1 = item.address.address_line_1 || '';
                      address2 = item.address.address_line_2 || '';
                      city = item.address.city || '';
                      state = item.address.state || '';
                      zip = item.address.zip || '';
                      country = item.address.country || '';
                      location_notes = item.address.location_notes || '';
                    }
                  });
                } else {
                    locationDetails.forEach((type) => {
                      if (this.state.locationtype_id === type.locationtype_id) {
                        address1 = type.addressline1;
                        address2 = type.addressline2;
                        city = type.city;
                        state = type.state;
                        zip = type.zip;
                        country = type.country;
                        location_notes = type.location_notes;
                      }
                    });
                  }
                } else {
                if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
                  const locationtypesdata = [
                    { id: this.state.locationtype_id, label: this.props.t('API.LocationType.Kiosk') },
                  ];
                  this.setState({ locationtype: locationtypesdata });
                  const boxData = this.state.boxdata;
                  boxData.forEach((item) => {
                    if (this.state.box_id === item.id && item && item.address) {
                      address1 = item.address.address_line_1 || '';
                      address2 = item.address.address_line_2 || '';
                      city = item.address.city || '';
                      state = item.address.state || '';
                      zip = item.address.zip || '';
                      country = item.address.country || '';
                      location_notes = item.address.location_notes || '';
                    }
                  });
                }
                }
                if (typeId === DEVICE_TYPE.Hold) {
                  this.setState({ isAlreadyOnHold: true });
                } else {
                  this.setState({ isAlreadyOnHold: false });
                }
                if (typeId === DEVICE_TYPE.Assigned) {
                  this.setState({ isAlreadyAssigned: true });
                } else {
                  this.setState({ isAlreadyAssigned: false });
                }
                if (typeId === DEVICE_TYPE.Stocked) {
                  this.setState({ is_stocked: true });
                } else {
                  this.setState({ is_stocked: false });
                }
                let Patient = [];
                Patient.push({ id: basicDetails.id, name: basicDetails.name });
                let Arraycart = [];
                for (let i = 0; i < rxItems.length; i++) {
                  let item = {};
                  item.id = i;
                  item.rxNo = rxItems[i].rx_no;
                  item.drugname = rxItems[i].drug_name;
                  item.ndcCode = rxItems[i].ndc_code;
                  item.price = rxItems[i].price;
                  item.qty = rxItems[i].qty;
                  item.ConsultRequire = rxItems[i].is_consultrequire;
                  item.orderid = rxItems[i].id;
                  item.is_order_released = rxItems[i].is_order_released;
                  item.is_returnable = rxItems[i].is_returnable
                  item.is_controlledsubstances = rxItems[i].is_controlledsubstances
                  Arraycart.push(item);
                }
                this.setState({
                  isPatientSelectionDisabled: true,
                  searchedItems: {
                    FirstName: basicDetails.first_name,
                    LastName: basicDetails.last_name,
                    DateOfBirth: basicDetails.dob_str,
                    MobileNo: this.state && this.state.phone,
                    EmailID: this.state && this.state.EmailID,
                    AddressLine1: address1,
                    AddressLine2: address2,
                    City: city,
                    State: state,
                    Zip: zip,
                    Country: country,
                    location_notes: location_notes,
                    isCoolItem: orders && orders.is_cool_item,
                    notes: basicDetails.notes,
                  },
                  rxNumber: rxNo,
                  selectedBinId: bindId,
                  selectedBinSize: binSize ? binSize : '',
                  stockCode: stockcode,
                  pickupCode: pickupcode,
                  orderId: orderId,
                  selectedPatient: Patient[0],
                  readOnly: true,
                  scanRxItems: Arraycart,
                  patientNotes: this.validateFields(basicDetails && basicDetails.notes),
                  isPatientRecordNumberRequired: false
                });
                this.getPaymentDetails(orderId, basicDetails.id);
              }
              this.getCartRxNumbers();
              this.setState({ assignedPrescription: data.response.box });
              this.forceUpdate();
            }
          }).catch(() => {
            this.setState({ loader: false });
          });
      }
    }
  };

  GetFormattedDate(dob) {
    let tempDate = new Date(dob);
    let formattedDate = ('0' + tempDate.getDate()).slice(-2);
    let formattedMonth = ('0' + (tempDate.getMonth() + 1)).slice(-2);
    let formattedYears = tempDate.getFullYear();
    let dateString =
      formattedMonth + '/' + formattedDate + '/' + formattedYears;
    return dateString;
  }

  sendOrederStatusEmail(reqDetails) {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'emailHoldStatus', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reqDetails),
    }).then((res) => { return res.text() })
    .then(() => {
      this.setState({ loader: false });
    }).catch(() => {
      this.setState({ loader: false });
    });
  }

  reminderHandler = () => {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'reminder/notification', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(this.state.reminderData),
    })
      .then((response) => {
        if (response.status === 200) {
          this.setState({ searchedRxNo: [] });
          toast.success(this.props.t('Prescriptions.Messages.NotificationSent'));
        }
        try {
          return response.text();
        } catch (error) {
          this.setState({ loader: false });
          return null;
        }
      })
      .then((uData) => {
        // this.getBoxes();
        // searchedRxNumbers = [];
        // this.setState({
        //   selectedBinId: "",
        //   searchedItems: [],
        //   rxNumber: "",
        // });
        // this.textInput.current.focus();
        this.setState({ loader: false });
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  changeOrderStatus(status) {
    this.setState({ loader: true });
    let bin_info;
    let reqDetails = {};
    if (status === 'pause') {
      bin_info = {
        id: this.state.orderId,
        type_id: DEVICE_TYPE.Hold,
      };
      reqDetails = {
        box_id: this.state.box_id,
        pucode: this.state.pickupCode,
        onHold: true,
      };
      this.sendOrederStatusEmail(reqDetails);
    } else if (status === 'play') {
      bin_info = {
        id: this.state.orderId,
        type_id: DEVICE_TYPE.Stocked,
      };
      reqDetails = {
        box_id: this.state.box_id,
        pucode: this.state.pickupCode,
        onHold: false,
      };
      this.sendOrederStatusEmail(reqDetails);
    } else if (status === 'remove') {
      bin_info = {
        id: this.state.orderId,
        type_id: DEVICE_TYPE.RemoveRx,
      };
    }

    fetch(process.env.REACT_APP_BASEURL + 'updateStatusOfRx', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(bin_info),
    })
      .then((response) => {
        try {
          if (
            bin_info.type_id === assignmentstatus.REMOVE_RX &&
            response.status === 200
          ) {
            const event_params = {
              event_name: EVENT_CRUD_TYPES.UPDATE,
              event_type_name: EVENT_TYPES.REMOVE_RX,
              description:
                'Prescription is Remove with stock code ' +
                this.state.stockCode,
              object_id: assignmentstatus.REMOVE_RX,
              tofor_id: this.state.orderId,
              box_id: this.state.box_id,
            };
            new EventLogHandler().handleEventLog(event_params);
          }
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        const { t } = this.props;
        this.setState({ loader: false });
        if (status === 'pause') {
          toast.success(t('Prescriptions.Messages.OnHold'));
        } else if (status === 'play') {
          toast.success(t('Prescriptions.Messages.NotOnHold'));
        } else if (status === 'remove') {
          toast.success(t('Prescriptions.Messages.RemovedRx'));
        }
        this.setState({
          selectedBinId: '',
          selectedBinSize: '',
          searchedItems: [],
          rxNumber: '',
          //box_id: "",
          isVisibleForPause: false,
          readOnly: false,
          scanRxItems: [],
          EmailID: '',
          phone: '',
          isPatientSelectionDisabled: false,
          makePreAssignmentAPICall: true,
        });
        // this.textInput.current.focus();
        this.ClearFields('clear');
        searchedRxNumbers = [];
        this.getBoxes();
        this.setState({ makePreAssignmentAPICall: false });
      });
  }

  getSelectedUnitName = (index) => {
    if (index === 1) {
      this.setState({ selectedUnitName: 'L60 (Locker Addon with 60 bins)' });
    } else if (index === 2) {
      this.setState({ selectedUnitName: 'HD36 (Locker Addon with 36 bins)' });
    } else if (index === 3) {
      this.setState({ selectedUnitName: 'Cool (Temp Controlled with 8 bins)' });
    } else if (index === 4) {
      this.setState({ selectedUnitName: 'C30 (C30 with 30 bins)' });
    } else {
      this.setState({ selectedUnitName: 'Locker (Main Unit with 46 bins)' });
    }
  };

  handleConsultrequire = (index) => {
    if (this.state.scanRxItems.length > 0) {
      let newState = this.state.scanRxItems.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            ConsultRequire: !this.state.scanRxItems[index].ConsultRequire,
          };
        }
        return item;
      });
      this.setState({
        scanRxItems: newState,
      });
    }
  };
  checkBoxHandler = (value) => {
    this.setState({ default_courier_selected: value });
  };
  getDueAmount = () => {
    let orderAmount = 0;
    for (let i = 0; i < this.state.scanRxItems.length; i++) {
      if (!isNaN(this.state.scanRxItems[i].price)) {
        let amount = parseFloat(this.state.scanRxItems[i].price);
        orderAmount = orderAmount + amount;
      }
    }
    return `$${orderAmount.toFixed(2)}`;
  };

  getPaymentDetails = (orderId, customerId) => {
    this.setState({ loader: true });
    fetch(
      `${process.env.REACT_APP_BASEURL}payments/validate-payment?order_id=${orderId}&customer_id=${customerId}`,
      {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    )
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        if (data) {
          this.setState({ isAmountPaid: data.res, loader: false });
        }
      });
  };
  ManualPickupNotification = (type) => {
    this.setState({ loader: true });
    let reqDetails = {
      box_id: this.state.box_id,
      pucode: this.state.pickupCode,
      emailID:
        this.state.searchedItems.EmailID || (this.state && this.state.EmailID),
      firstName: this.state.searchedItems.FirstName,
      lastName: this.state.searchedItems.LastName,
      AccountName: this.state.accountDetails && this.state.accountDetails.name,
      AccountAddress:
        this.state.accountDetails &&
        this.state.accountDetails.contact &&
        this.state.accountDetails.contact.address &&
        this.state.accountDetails.contact.address.address_line_1 +
        ' ' +
        this.state.accountDetails.contact.address.address_line_2 +
        ' ',
      AccountAddress2:
        this.state.accountDetails &&
        this.state.accountDetails.contact &&
        this.state.accountDetails.contact.address &&
        this.state.accountDetails.contact.address.city +
        ', ' +
        this.state.accountDetails.contact.address.state +
        ' ' +
        this.state.accountDetails.contact.address.zip,
      location_notes: this.state.searchedItems.location_notes,
    };
    if (type === 1) {
      this.changeOrderStatus('remove');
    }
    if (type === 2) {
      this.changeOrderStatus('pause');
    }
    if (type === 3) {
      this.changeOrderStatus('play');
    }
    fetch(process.env.REACT_APP_BASEURL + 'emailPickupNotification', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reqDetails),
    })
      .then((response) => {
        if (response.status === 200) {
          this.setState({ searchedRxNo: [], loader: false });
          toast.success(this.props.t('Prescriptions.Messages.NotificationSent'));
        }
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.getBoxes();
        searchedRxNumbers = [];
        this.setState({
          selectedBinId: '',
          selectedBinSize: '',
          searchedItems: [],
          rxNumber: '',
          scanRxItems: [],
          loader: false
        });
        // this.textInput.current.focus();
      }).catch(() => {
        this.setState({ loader: false });
      });
  };
  ClearFields = (param) => {
    searchedRxNumbers = [];
    this.setState({
      selectedBinId: '',
      searchedItems: [],
      scanRxItems: [],
      rxNumber: '',
      selected: [],
      box: [],
      hasError: false,
      box_id: null,
      pharmacyDetails: {},
      accountDetails: {},
      BinStatus: [],
      deactivatedBins: [],
      assignedPrescription: {},
      isVisibleForPause: false,
      isBoxSelected: false,
      selectedUnitName: '',
      customervalues: [],
      customerList: [],
      popupDOB: null,
      copyScanRxItems: [],
      isPaymentRequired: false,
      CoPayAmountIndex: '',
      CoPayAmountValue: '0.00',
      readOnly: false,
      selectedPatient: {},
      expansionUnits: [
        {
          id: -1,
          order: 0,
          pos: 'M',
          selectedUnitIndex: 0,
          box_position: 0,
        },
      ],
      box_expansions_id: '',
      isADACompatible: false,
      locationtype_id: '',
      EmailID: '',
      phone: '',
      isEpicHasValidRx: true,
      isEpicHasValidRxMessage: '',
      is_stocked: false,
      order: 'desc',
      orderBy: 'created_on',
      PrintFirstName: '',
      PrintLastName: '',
      ADAData: [],
      SearchResultDialogOpen: false,
      reminderData: [],
      source_location: '',
      delivery_notes: '',
      order_notes: '',
      patient_notes: '',
      boxdata: [],
      prefer_location_name: '',
      courier_type: [],
      courier_tracking: '',
      default_courier_selected: '',
      isEdit: false,
      indexNo: null,
      page: 0,
      rowsPerPage: 10,
      printDialogOpen: false,
      selectedObject: [],
      searchObj: {
        searchTxt: '',
        pageNo: 0,
        pageSize: 10,
        sortOrder: 'desc',
      },
      patientSearchInput: '',
      openAutoComplete: false,
      isVerifyingBin: false,
      isVerifyingBinMessage: '',
      doesPatientSelected: false,
      boxTypeId: '',
      brandPhone: '',
      brandName: '',
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      patientNotes: '',
      patientNotesReadOnly: true,
      selectedBinSize: '',
      isBinSizeRequired: false,
      isBinIdRequired: false,
      key: this.state.key + 1,
      isPatientSelectionDisabled: false,
      isPatientRecordNumberRequired: false,
    });
    let autoCompleteResetElement = document.getElementsByClassName('MuiAutocomplete-clearIndicator')
    if(autoCompleteResetElement.length > 0) {
      autoCompleteResetElement[0].click();
    }
    if(param === 'clear') {
      this.setState({ searchedItems: [], basicDetails: null });
    }
    this.BindPatientId(param);
    this.getBoxes();
    let kioskId = 'a5bd2ad0-0780-42cd-a270-7e76c4f20500';
    this.getAllBoxes(kioskId);
  };

  onInputChange = (event) => {
    const { searchedItems } = this.state;
    searchedItems[event.target.name] = event.target.value;
    this.setState({ [event.target.name]: event.target.value, searchedItems });
  };
  handleConsultClick = () => {
    this.setState({ detailDialogOpen: true });
  };

  handleConsultClose = () => {
    this.setState({ detailDialogOpen: false });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  onSearchChange = (event) => {
    const searchString = event.target.value;
    this.setState(
      { searchObj: { ...this.state.searchObj, searchTxt: searchString } },
      () => {
        if (searchString.length > 2) {
          this.FetchSearchResult();
        } else {
          searchedRxNumbers = [];
          this.setState({
            selectedBinId: '',
            selectedBinSize: '',
            searchedItems: [],
            rxNumber: '',
            isVisibleForPause: false,
            EmailID: '',
            phone: '',
            isEpicHasValidRx: true,
            isEpicHasValidRxMessage: '',
          });
        }
      }
    );
  };

  FetchSearchResult = () => {
    let FilterObj = {
      searchtext: this.state.searchObj.searchTxt,
      pageNo: this.state.searchObj.pageNo,
      pageSize: this.state.searchObj.pageSize,
      sortOrder: this.state.searchObj.sortOrder,
    };
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'getPrescriptionSearchResult', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(FilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.setState({
          totalSearchRecords: uData && uData['total'],
          loader: false,
          innerSearchLoader: false,
        });
        if (
          uData &&
          Array.isArray(uData['results']) &&
          uData['results']['length'] > 0
        ) {
          if (uData['results']['length'] === 1) {
            let BinId = uData['results'][0].bin_id;
            let pm_id = uData['results'][0].pm_id;
            this.getPrescriptionDetails(BinId, pm_id);
          } else
            this.setState({
              selectedObject: uData['results'],
              SearchResultDialogOpen: true,
            });
        } else {
          searchedRxNumbers = [];
          this.setState({
            selectedBinId: '',
            selectedBinSize: '',
            searchedItems: [],
            rxNumber: '',
            isVisibleForPause: false,
            EmailID: '',
            phone: '',
            isEpicHasValidRx: true,
            isEpicHasValidRxMessage: '',
            SearchResultDialogOpen: false,
            innerSearchLoader: false,
            searchObj: { pageNo: 0, pageSize: 10, sortOrder: 'desc' },
          });
        }
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  handleSearchClose = (event) => {
    event.preventDefault();
    this.setState({
      SearchResultDialogOpen: false,
      selectedObject: [],
      innerSearchLoader: false,
      searchObj: { searchTxt: '', pageNo: 0, pageSize: 10, sortOrder: 'desc' },
    });
  };

  handlePUcodeClick = (event, BinId, pm_id, boxid) => {
    event.preventDefault();
    this.getPharmacyDetails(boxid);
    this.getExpansionBins(boxid);    
    this.getAssignedBins(boxid);
    this.setState({ box_id: boxid });
    setTimeout(() => {
      this.handleSearchClose(event);
      this.getPrescriptionDetails(BinId, pm_id);
    }, 100);
  };

  handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      this.handleDialogValidate();
    }
  };

  courierTrackingHandler = (evt) => {
    this.setState({ courier_tracking: evt.target.value });
  };

  BindPatientId = (param) => {
    const { searchedItems, basicDetails } = this.state;
    if(param === 'clear') {
      return ''
    } else {
      if (
        searchedItems &&
        searchedItems.PatientID &&
        searchedItems.PatientID !== null &&
        searchedItems.PatientID !== 'null'
      ) {
        return searchedItems.PatientID;
      } else if (
        basicDetails &&
        basicDetails.patient_id &&
        basicDetails.patient_id !== null &&
        basicDetails.patient_id !== 'null'
      ) {
        return basicDetails.patient_id;
      } else {
        return '';
      }
    }
  };

  updateDueAmount = (orderid, dueAmount) => {
    this.setState({ loader: true });
    const updateParams = {
      orderid: orderid,
      dueamount: dueAmount,
    };
    try {
      fetch(process.env.REACT_APP_BASEURL + 'updateorderdueamout', {
        method: 'PUT',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateParams),
      })
        .then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          if (res) {
            this.setState({ loader: false });
            toast.success(
              res && res.UpdateDueAmount && res.UpdateDueAmount.message
            );
            //this.getPrescriptionDetails(this.state.binid, this.state.pmid);
          } else {
            this.setState({ loader: false });
            toast.error(res.error);
          }
        });
    } catch (error) {
      this.setState({ loader: false });
      console.log(error);
    }
  };

  handleOpenDueAmountEditInput = (index) => {
    this.setState({ indexNo: index });
  };

  handleCloseDueAmountEditInput = (index, orderid) => {
    this.setState({ indexNo: Math.random() || index });
    const orderdueamount =
      this.state.scanRxItems &&
      this.state.scanRxItems.find((item, i) => item.orderid === orderid);
    this.updateDueAmount(orderid, orderdueamount['price']);
  };

  onHandleChangeInputValue = (id, type, value) => {
    if (type === 'price') {
      const items =
        this.state.scanRxItems &&
        this.state.scanRxItems.map((item, i) => {
          if (item.id === id) {
            return { ...item, price: parseFloat(value) };
          }
          return item;
        });
      this.setState({ scanRxItems: items });
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { selectedObject } = this.state;
    this.setState(
      { searchObj: { ...this.state.searchObj, pageNo: page } },
      () => {
        if (selectedObject && selectedObject.length > 0) {
          this.setState({ innerSearchLoader: true });
          this.FetchSearchResult();
        }
      }
    );
  };

  handleChangeRowsPerPage = (event) => {
    const { selectedObject } = this.state;
    this.setState(
      {
        searchObj: {
          ...this.state.searchObj,
          pageSize: event.target.value,
          pageNo: 0,
        },
      },
      () => {
        if (selectedObject && selectedObject.length > 0) {
          this.setState({ innerSearchLoader: true });
          this.FetchSearchResult();
        }
      }
    );
  };

  handlePrintReceipt = () => {
    this.setState({
      PrintFirstName:
        this.state &&
        this.state.searchedItems &&
        this.state.searchedItems.FirstName,
      PrintLastName:
        this.state &&
        this.state.searchedItems &&
        this.state.searchedItems.LastName,
      PrintDateOfBirth:
        this.state &&
        this.state.searchedItems &&
        this.state.searchedItems.DateOfBirth,
      PrintisCoolItem:
        this.state &&
        this.state.searchedItems &&
        this.state.searchedItems.isCoolItem,
      printDialogOpen: true,
    });
    setTimeout(() => {
      window.print();
      this.getBoxes();
      searchedRxNumbers = []; // TODO:
      this.setState({
        printDialogOpen: false,
        selectedBinId: '',
        selectedBinSize: '',
        isBinSizeRequired: false,
        isBinIdRequired: false,
        searchedItems: [],
        rxNumber: '',
        isVisibleForPause: false,
        scanRxItems: [],
        EmailID: '',
        phone: '',
        brandName: '',
        brandPhone: '',
        isPatientSelectionDisabled: false,
        isPatientRecordNumberRequired: false,
      });
      this.textInput.current.focus();
    }, 500);
  };

  validateFields = (value) => {
    if (!['', undefined, 'undefined', null, 'null'].includes(value)) {
      return value;
    }
    return '';
  };

  setAutoCompleteOpen = (value) => {
    this.setState({ openAutoComplete: value });
  };

  onOptionSelect = async (event, value, reason) => {
    if (reason === 'selectOption') {
      if (value && value.id) {
        this.setState({
          showDialog: true,
          searchedItems: {},
          scanRxItems: [],
          selectedPatient: value,
          isEdit: false,
          doesPatientSelected: true,
        });
        const pObj = this.state.customerList.find((x) => x.id === value.id);
        if (pObj && pObj.id) {
          let locationDetails = pObj.customerLocations;
          let defaultLocation = {};
          if (locationDetails.length > 0) {
            const locationtypesdata = locationDetails.map((type) => {
              if (type.is_default_address) {
                defaultLocation = { ...type };
              }
              const base = mapLocationTypesHelper([type], this.props.t)[0];
              return {
                ...type,
                id: base.id,
                label: base.label,
              };
            });
            const box_id =
              pObj.box_id ||
              defaultLocation.box_id ||
              locationtypesdata[0].box_id;
            const locationtype_id =
              defaultLocation.id || locationtypesdata[0].id;
            this.setState({
              locationtype: locationtypesdata,
              locationtype_id,
              box_id,
            });
            await this.handletypeChange(locationtype_id);
            await this.handleChange(box_id);
          }
        }
      }
    } else {
      this.setState({ customervalues: [], customerList: [] });
      this.setAutoCompleteOpen(false);
    }
  };

  saveCustomerMaster = async (type) => {
    const { selectedBinId, scanRxItems, EmailID, phone, box_id, selectedBinSize, deactivatedBins } = this.state;
    if (deactivatedBins && deactivatedBins.includes(selectedBinId)) {
      toast.error(this.props.t('Toast.Error.BinDeactivated'));
      return;
    }
    const { t } = this.props;
    this.setState({ hasError: false });
    if (!box_id) {
      this.setState({ hasError: true });
    } else {
      this.setState({ loader: true });
    }
    let decision = true;
    if (this.state.locationtype_id === LOCATION_TYPE.Kiosk) {
      if (this.is_pre_assignment) {
        if ([undefined, 'undefined', null, 'null', ''].includes(selectedBinSize)) {
          this.setState({ isBinSizeRequired: true, loader: false })
          decision = false;
        }
      } else {
        if ([undefined, 'undefined', null, 'null', ''].includes(selectedBinId)) {
          this.setState({ isBinIdRequired: true, loader: false });
          decision = false;
        }
      }
      const patientRecordNumber = document.getElementById('Patient Record Number').value;
      if ([undefined, 'undefined', null, 'null', ''].includes(patientRecordNumber)) {
        this.setState({ isPatientRecordNumberRequired: true, loader: false });
        decision = false;
      }
    }
    this.setState({ loader: false });
    if (decision) {
      this.setState({ loader: true });
      if (scanRxItems.length > 1) {
        const isValidPrescription = await this.checkPrescriptionStatus();
        if (isValidPrescription) {
          if (EmailID === '') {
            toast.error(this.props.t('Toast.Error.EnterEmail'));
            this.setState({ loader: false });
            return;
          }
          if (phone === '') {
            toast.error(this.props.t('Toast.Error.EnterMobile'));
            this.setState({ loader: false });
            return;
          }
          this.setState({
            copyScanRxItems: this.state.scanRxItems
          });
          this.getCartRxNumbers();
          const _prepareServePrescriptionRequest = await this.prepareServePrescriptionRequest();
          fetch(process.env.REACT_APP_BASEURL + "serve/prescription", {
            method: "post",
            withCredentials: true,
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user")).signInUserSession
                  .idToken.jwtToken,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(_prepareServePrescriptionRequest)
          }).then(response => {
            try {
              return response.json();
            } catch (error) {
              return null;
            }
          }).then((serverPrescriptionResponse) => {
            if (type === 1) {
              this.setState({
                PrintFirstName:
                  this.state &&
                  this.state.searchedItems &&
                  this.state.searchedItems.FirstName,
                PrintLastName:
                  this.state &&
                  this.state.searchedItems &&
                  this.state.searchedItems.LastName,
                PrintDateOfBirth:
                  this.state &&
                  this.state.searchedItems &&
                  this.state.searchedItems.DateOfBirth,
                PrintisCoolItem: this.state && this.state.isSelectedFlag,
                printDialogOpen: true,
              });
              setTimeout(() => {
                window.print();
                this.setState({
                  printDialogOpen: false,
                  brandName: '',
                  brandPhone: '',
                  storage_location: '',
                  order_notes: '',
                  selectedBinId: '',
                  selectedBinSize: '',
                  searchedItems: [],
                  rxNumber: '',
                  scanRxItems: [],
                  EmailID: '',
                  phone: '',
                  loader: false,
                  patientNotes: '',
                  patientNotesReadOnly: true,
                  key: this.state.key + 1,
                  isPatientSelectionDisabled: false,
                  makePreAssignmentAPICall: true,
                }, () => this.socket && this.socket.emit('updateConsole'));
                this.getBoxes();
                toast.success(t("Assign.RxAssignedSuccessfully"));
              }, 500);
            } else {
              toast.success(t("Assign.RxAssignedSuccessfully"));
              this.setState({
                printDialogOpen: false,
                brandName: '',
                brandPhone: '',
                storage_location: '',
                order_notes: '',
                selectedBinId: '',
                selectedBinSize: '',
                searchedItems: [],
                rxNumber: '',
                scanRxItems: [],
                EmailID: '',
                phone: '',
                loader: false,
                patientNotes: '',
                patientNotesReadOnly: true,
                key: this.state.key + 1,
                isPatientSelectionDisabled: false,
                makePreAssignmentAPICall: true,
              }, () => this.socket && this.socket.emit('updateConsole'));
              this.getBoxes();
            }
            this.setState({ makePreAssignmentAPICall: false });
          }).catch(() => {
            this.setState({ loader: false });
          })
        }
      } else {
        toast.error(
          t("Assign.OneItemRequired")
        );
        this.setState({ loader: false });
        return;
      }
    }
  }

  checkIfCodesExists = (data) => {
    this.setState({ loader: true });
    let codes = {...data}
    fetch(process.env.REACT_APP_BASEURL + 'verify/codes', {
      crossDomain: true,
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(codes),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((res) => {
        if (res && res.isExist === true) {
          const _stockCode = randomized('A0', 6, { exclude: '0oOiIlL1&zZ' });
          const _pickupCode = randomized('A0', 6, { exclude: '0oOiIlL1&zZ' });
          codes = {
            stockCode: _stockCode,
            pickupCode: _pickupCode,
          };
        }
        // Codes stored in state only - fetched fresh from database before printing
        this.setState({
          stockCode: codes.stockCode,
          pickupCode: codes.pickupCode,
          loader: false
        });
      }).catch(() => {
        this.setState({ loader: false });
      });
  };

  checkPrescriptionStatus = async () => {
    this.setState({ loader: true });
    const { scanRxItems, selectedBinId, box_id, accountDetails } = this.state;
    if (scanRxItems.length > 0) {
      let obj = {
        bin_id: selectedBinId,
        box_id: box_id,
        account_id: accountDetails && accountDetails.id,
      };
      let codes = {
        stockCode: this.state.stockCode,
        pickupCode: this.state.pickupCode,
      };
      this.checkIfCodesExists(codes);
      if (this.is_pre_assignment) {
        return true
      } else {
        return fetch(process.env.REACT_APP_BASEURL + 'prescription/status/check', {
          crossDomain: true,
          method: 'post',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
          },
          body: JSON.stringify(obj),
        }).then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        }).then((res) => {
          if (
            (res && res.statusCode === 200) ||
            (res && res.statusCode === 404)
          ) {
            this.setState({ loader: false });
            return true;
          } else {
            this.setState({ loader: false });
            return false;
          }
        }).catch(() => {
          this.setState({ loader: false });
        })
      }
    }
  }

  prepareServePrescriptionRequest = async () => {
    const { searchedItems, phone, EmailID, box_id, locationtype_id,
      selectedPatient, selectedBinId, stockCode, pickupCode, box_position,
      source_location, storage_location, order_notes, location_notes,
      orderId, default_courier_selected, courier_tracking, isSelectedFlag, selectedBinSize } = this.state;
    let emailAddress, phoneNumber;
    if (locationtype_id === LOCATION_TYPE.Kiosk) {
      emailAddress = EmailID;
      phoneNumber = phone;
    } else {
      const i = this.state.customerList.findIndex(
        (x) => x.id === selectedPatient.id
      );
      if (i !== -1) {
        emailAddress = this.state.customerList[i].contacts[0].email;
        phoneNumber = this.state.customerList[i].contacts[0].phone;
      } else {
        emailAddress = EmailID;
        phoneNumber = phone;
      }
    }
    return {
      first_name: searchedItems.FirstName,
      middle_name: searchedItems.MiddleName || null,
      last_name: searchedItems.LastName,
      dob: searchedItems.DateOfBirth,
      phone: phoneNumber,
      email: emailAddress,
      parent_box_id: box_id,
      patient_id: searchedItems.PatientID || uuidv4(),
      locationtype_id: locationtype_id,
      address1: searchedItems.AddressLine1,
      address2: searchedItems.AddressLine2,
      city: searchedItems.City,
      state: searchedItems.State,
      zip: searchedItems.Zip,
      country: searchedItems.Country,
      location_notes: searchedItems.location_notes,
      notes: this.validateFields(searchedItems && searchedItems.notes) || this.state.patientNotes,
      bin_size: selectedBinSize,
      prescription: {
        bin_id: selectedBinId,
        type_id: locationtype_id === LOCATION_TYPE.Kiosk ? assignmentstatus.ASSIGNED : DEVICE_TYPE.Ready,
        stock_code: stockCode,
        pucode: pickupCode,
        box_id: box_id,
        box_position: box_position,
        source_location: source_location,
        locationtype_id: locationtype_id,
        storage_location: storage_location,
        order_notes: order_notes,
        location_notes: searchedItems.location_notes || location_notes,
        order_id: orderId,
        courier_type: default_courier_selected,
        tracking_number: courier_tracking,
        iscool_item: isSelectedFlag,
        items: await this.preparePrescriptionItemRequest(),
        is_fastlane: false
      }
    }
  }

  preparePrescriptionItemRequest = async () => {
    let prescriptionItemArray = [];
    const { copyScanRxItems } = this.state;
    const scanrxIndex = copyScanRxItems.findIndex(
      (x) => x.rxNo === ''
    );
    if (scanrxIndex > -1) {
      copyScanRxItems.splice(scanrxIndex, 1);
    }
    for (let i = 0; i < copyScanRxItems.length; i++) {
      let singleItem = copyScanRxItems[i];
      prescriptionItemArray.push({
        rx_no: singleItem.rxNo,
        drug_name: singleItem.drugname,
        ndc_code: singleItem.ndcCode,
        price: this.ReplaceAmount(singleItem.price),
        expires_on: [undefined, 'undefined', null, 'null', ''].includes(singleItem.ExpirationDate) ? '01/01/2020' : singleItem.ExpirationDate,
        qty: singleItem.qty,
        strength: singleItem.strength,
        route: singleItem.route,
        doseage_form: singleItem.doseage_form,
        non_proprietary_name: singleItem.non_proprietary_name,
        fillNumber: [undefined, 'undefined', null, 'null', ''].includes(singleItem.fillNumber) ? 0 : singleItem.fillNumber,
        is_consultrequire: [undefined, 'undefined', null, 'null', ''].includes(singleItem.ConsultRequire) ? false : singleItem.ConsultRequire,
        prescriptionnumber: [undefined, 'undefined', null, 'null', ''].includes(singleItem.prescriptionNumber) ? '' : singleItem.prescriptionNumber,
        is_returnable: [undefined, 'undefined', null, 'null', ''].includes(singleItem.IsReturnable) ? false : (singleItem.IsReturnable || singleItem.is_returnable),
        is_controlledsubstances: [undefined, 'undefined', null, 'null', ''].includes(singleItem.is_controlledsubstances) ? false : singleItem.is_controlledsubstances
      })
    }
    return prescriptionItemArray;
  }

  handleBinSizeChange = async (event) => {
    event.preventDefault();
    this.setState({
      selectedBinSize: event.target.value,
      isBinSizeRequired: false,
    });
  };

  confirmBinOkButton = () => {
    this.setState({
      isVerifyingBin: false,
      isVerifyingBinMessage: '',
      selectedBinId: '',
    });
  };

  getAvailableBinsCount = async (box_id) => {
    fetch(process.env.REACT_APP_BASEURL + 'pre-assignment/getAvailableBinsCount/' + box_id, {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
      },
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((result) => {
        let { largeCounts, mediumCounts, smallCounts, coolCounts } = result.data;
        this.setState({ largeBinsCount: largeCounts, mediumBinsCount: mediumCounts, smallBinsCount: smallCounts, coolBinsCount: coolCounts });
      })
      .catch(error => console.error(error));
  }

  handleIsReturnable = (index) => {
    const { scanRxItems } = this.state;
    if (scanRxItems && scanRxItems.length > 0) {
      scanRxItems[index].IsReturnable = !scanRxItems[index].IsReturnable;
      this.forceUpdate();
    }
  }

  handleIsControlledSubstance = (index) => {
    const { scanRxItems } = this.state;
    if (scanRxItems && scanRxItems.length > 0) {
      scanRxItems[index].is_controlledsubstances = !scanRxItems[index].is_controlledsubstances;
      this.forceUpdate();
    }
  }

  setPermission = () => {
    let permissions = JSON.parse(sessionStorage.getItem("permissions"));
    let _checkUserRole = JSON.parse(sessionStorage.getItem("permissionUser"));
    if(_checkUserRole === userroles.SUPERADMIN) {
      this.setState({ 
        isManualOverridePermissionEnabled: true, 
        prescriptionUnAssign: true, 
        prescriptionAssign: true, 
        prescriptionView: true,
        prescriptionDirectPickup: true,
        prescriptionRemind: true,
        prescriptionConsult: true,
        prescriptionHoldResume: true,
        prescriptionAcDc: true, });
    } else {
      if (permissions && permissions.length > 0) {
        const manualOverride = permissions.filter((item) => {
          return item.permission_entity_type === "Manual Override"
        });
        const assignPrescriptions = permissions.filter((item) => {
          return item.permission_entity_type === "Assign Prescription"
        });

        if (manualOverride.length > 0) {
          this.setState({ isManualOverridePermissionEnabled: manualOverride.some((x) => x.name.trim() === 'Open Bin' && x.is_allowed === 1) })
        } else {
          this.setState({ isManualOverridePermissionEnabled: false });
        }

        if (assignPrescriptions.length > 0) {
          this.setState({
            prescriptionUnAssign: assignPrescriptions.some((x) => x.name.trim() === 'UnAssign' && x.is_allowed === 1),
            prescriptionAssign: assignPrescriptions.some((x) => x.name.trim() === 'Assign' && x.is_allowed === 1),
            prescriptionView: assignPrescriptions.some((x) => x.name.trim() === 'View' && x.is_allowed === 1),
            prescriptionRemind: assignPrescriptions.some((x) => x.name.trim() === 'Remind' && x.is_allowed === 1),
            prescriptionDirectPickup: assignPrescriptions.some((x) => x.name.trim() === 'Direct Pickup' && x.is_allowed === 1),
            prescriptionConsult: assignPrescriptions.some((x) => x.name.trim() === 'Consult' && x.is_allowed === 1),
            prescriptionAcDc: assignPrescriptions.some((x) => x.name.trim() === 'Activate/DeActivate' && x.is_allowed === 1),
            prescriptionHoldResume: assignPrescriptions.some((x) => x.name.trim() === 'Hold/Resume' && x.is_allowed === 1),
          })
        } else {
          this.setState({
            prescriptionUnAssign: false,
            prescriptionAssign: false,
            prescriptionView: false,
            prescriptionDirectPickup: false,
            prescriptionRemind: false,
            prescriptionConsult: false,
            prescriptionHoldResume: false,
            prescriptionAcDc: false,
          });
        }
      } else {
        this.setState({ 
          isManualOverridePermissionEnabled: false, 
          prescriptionUnAssign: false, 
          prescriptionAssign: false, 
          prescriptionView: false,
          prescriptionDirectPickup: false,
          prescriptionRemind: false,
          prescriptionConsult: false,
          prescriptionHoldResume: false,
          prescriptionAcDc: false 
        });
      } 
    }
  }

  checkIfBinIsOccupedFromAnotherLocation = (type) => {
    const { box_id, selectedBinId, binid } = this.state;
    if(this.state.locationtype_id !== LOCATION_TYPE.Kiosk) {
      if([undefined, 'undefined', null, 'null', ""].includes(selectedBinId)) {
        console.log("No action required for other types of locations.");
        this.saveCustomerMaster(type);
        return;
      }
      if([undefined, 'undefined', null, 'null', ""].includes(binid)) {
        console.log("No action required for other types of locations.");
        this.saveCustomerMaster(type);
        return;
      }
    }
    fetch(process.env.REACT_APP_BASEURL + "api/v2/orders/bin/status", {
      crossDomain: true,
      method: "post",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify({
        box_id: box_id,
        bin_id: selectedBinId || binid,
      }),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          console.log(
            `Preflight error while processing request ${error && error.message}`
          );
          return null;
        }
      })
      .then(async (res) => {
        if (res && res.isOccupied === true) {
          toast.error(res.message);
        } else {
          this.saveCustomerMaster(type);
        }
      })
      .catch((error) => {
        toast.error(`Error while checking status ${error && error.message}`);
      });
  };

  render() {
    const { scanRxItems, copyScanRxItems, locale } = this.state;
    const itemCount = scanRxItems.length || copyScanRxItems.length || searchedRxNumbers.length;
    const {
      searchedItems,
      selectedBinId,
      stockCode,
      pickupCode,
      selected,
      hasError,
      isAlreadyOnHold,
      isAlreadyAssigned,
      locationtype,
      is_stocked,
      order,
      orderBy,
      openAutoComplete,
      customervalues,
      prescriptionView
    } = this.state;
    const { classes, t } = this.props;
    const binSizeTranslationObj = {
      Large : t("Unplugged.LargeBinSize"),
      Medium : t("Unplugged.MediumBinSize"),
      Small : t("Unplugged.SmallBinSize"),
      Cool : t("Unplugged.CoolBinSize")
    }
    const loading = openAutoComplete && customervalues.length === 0;
    return (
      <Box component='div'>
        <Paper className={classes.paperRoot}>
          {this.state.loader ? (
            <div className={classes.spinner}>
              <img
                className={classes.spinnerImage}
                src={spinner}
                alt='loading'
              />
            </div>
          ) : null}
          <div id='react-no-print'>
            <div id='react-no-print' className={classes.root}>
              <Dialog
                open={this.state.deleteDialogOpen || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'>
                <DialogTitle id='alert-dialog-title'>
                  {t("Assign.DeleteConfirmation")}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id='alert-dialog-description'>
                    {t('Unplugged.AreYouSureToDelete')}:
                    <ul>
                      {this.state.forDeletion &&
                        this.state.forDeletion.map(function (a) {
                          if (a.rxNo !== '') {
                            return <li>{a.drugname}</li>;
                          }
                          return null;
                        })}
                    </ul>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.deleteConfirmClose}
                    color='primary'
                    className={classes.primaryButton}>
                    {t('Unplugged.Cancel')}
                  </Button>
                  <Button
                    onClick={this.deleteConfirmed}
                    color='primary'
                    autoFocus
                    className={classes.primaryButton}>
                    {t('Unplugged.Delete')}
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={this.state.SearchResultDialogOpen || false}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                fullWidth={true}
                PaperProps={{
                  style: { maxWidth: '1315px' },
                }}>
                {/* <DialogTitle id="alert-dialog-title">{'Picked up by'}</DialogTitle> */}
                <DialogContent>
                  {this.state.innerSearchLoader && (
                    <Box component='div' className={classes.spinner}>
                      <Box
                        component='img'
                        className={classes.spinnerImage}
                        src={spinner}
                        alt='loading'
                      />
                    </Box>
                  )}
                  <Table aria-labelledby='tableTitle'>
                    <TableHead>
                      <TableRow style={{ height: '56px' }}>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Unplugged.SearchPopup.FirstName')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Unplugged.SearchPopup.LastName')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Unplugged.SearchPopup.Email')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Unplugged.SearchPopup.Phone')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Unplugged.SearchPopup.Bin')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Unplugged.SearchPopup.Status')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Unplugged.SearchPopup.StockCode')}
                        </TableCell>
                        <TableCell className={classes.tableHeadCell}>
                          {t('Unplugged.SearchPopup.PUCode')}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Array.isArray(this.state.selectedObject) &&
                        this.state.selectedObject.length > 0 ? (
                        this.state.selectedObject.map((n) => {
                          return (
                            <TableRow>
                              <TableCell className={classes.tablebody}>
                                {n.first_name}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.last_name}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.email}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.phone}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.bin_id}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                {n.status}
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                <a
                                  href=''
                                  title='View'
                                  style={{
                                    color: '#385cad',
                                    fontWeight: 500,
                                    textDecoration: 'none ',
                                    fontSize: '1rem',
                                  }}
                                  onClick={(event) =>
                                    this.handlePUcodeClick(
                                      event,
                                      n.bin_id,
                                      n.pm_id,
                                      n.box_id
                                    )
                                  }>
                                  {n.stock_code}
                                </a>
                              </TableCell>
                              <TableCell className={classes.tablebody}>
                                <a
                                  href=''
                                  title='View'
                                  style={{
                                    color: '#385cad',
                                    fontWeight: 500,
                                    textDecoration: 'none ',
                                    fontSize: '1rem',
                                  }}
                                  onClick={(event) =>
                                    this.handlePUcodeClick(
                                      event,
                                      n.bin_id,
                                      n.pm_id,
                                      n.box_id
                                    )
                                  }>
                                  {n.pucode}
                                </a>
                              </TableCell>
                            </TableRow>
                          );
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={5}>
                            {t('Unplugged.NoDataFound')}
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <ThemeProvider theme={localeTheme}>
                    <TablePagination
                      component='div'
                      count={this.state.totalSearchRecords || 0}
                      rowsPerPage={this.state.searchObj.pageSize}
                      page={this.state.searchObj.pageNo}
                      backIconButtonProps={{
                        'aria-label': 'Previous Page',
                      }}
                      nextIconButtonProps={{
                        'aria-label': 'Next Page',
                      }}
                      style={{ color: 'rgba(0, 0, 0, 0.54)' }}
                      onPageChange={this.handleChangePage}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                  </ThemeProvider>
                </DialogContent>
                <DialogActions style={{ marginTop: '-20px' }}>
                  <Button
                    onClick={(e) => {
                      this.handleSearchClose(e);
                    }}
                    color='primary'
                    className={classes.primaryButton}>
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
              <div id='react-no-print' className={classes.assignForm}>
                <div className={classes.main}>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          style={{ paddingTop: '2.4em' }}
                          sx={{ p: '0px' }}
                          className={classes.layoutBorder}>
                          <ThemeProvider theme={localeTheme}>
                            <Autocomplete
                              key={this.state.key}
                              id='search-unplugged-patient'
                              style={{ width: 375, marginTop: '-25px' }}
                              open={this.state && this.state.openAutoComplete}
                              onOpen={() => {
                                this.setAutoCompleteOpen(true);
                              }}
                              onClose={() => {
                                this.setAutoCompleteOpen(false);
                              }}
                              getOptionSelected={(option, value) =>
                                option.id === value.id
                              }
                              getOptionLabel={(option) => option.name}
                              options={this.state && this.state.customervalues}
                              loading={loading}
                              onChange={this.onOptionSelect}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={t('Unplugged.SearchPatient')}
                                  variant='standard'
                                  onChange={(ev) => {
                                    // dont fire API if the user delete or not entered anything
                                    if (
                                      ev.target.value !== '' ||
                                      ev.target.value !== null
                                    ) {
                                      this.onPatientChange(ev.target.value);
                                    }
                                  }}
                                  disabled={this.state.isPatientSelectionDisabled}
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <React.Fragment>
                                        {loading ? (
                                          <CircularProgress
                                            color='inherit'
                                            size={20}
                                          />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </React.Fragment>
                                    ),
                                  }}
                                />
                              )}
                            />
                          </ThemeProvider>
                        </TableCell>
                        <TableCell
                          className={classes.layoutBorder}
                          sx={{ width: '60%', p: '0px' }}>
                          <TextField
                            id='dateOfBirth'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Unplugged.PatientNotes')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            value={this.state.patientNotes}
                            onChange={(e) => !this.state.patientNotesReadOnly && this.setState({ patientNotes: e.target.value })}
                            readOnly={this.state.patientNotesReadOnly}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
                <div>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell
                          className={classes.layoutBorder}
                          sx={{ p: '0px' }}>
                          <TextField
                            id='firstName'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Unplugged.FirstName')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            value={this.validateFields(
                              searchedItems && searchedItems.FirstName
                            )}
                          />
                        </TableCell>
                        <TableCell
                          className={classes.layoutBorder}
                          sx={{ p: '0px' }}>
                          <TextField
                            id='lastName'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Unplugged.LastName')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                            value={this.validateFields(
                              searchedItems && searchedItems.LastName
                            )}
                          />
                        </TableCell>
                        <TableCell
                          className={classes.layoutBorder}
                          sx={{ p: '0px' }}>
                          <InputLabel
                            htmlFor='location_type_id'
                            style={{ fontSize: '13px' }}>
                            {t('Unplugged.DeliveryType')}
                          </InputLabel>
                          <Select
                            style={{ marginTop: '6px' }}
                            fullWidth={true}
                            value={this.state.locationtype_id || ''}
                            onChange={(e) =>
                              this.handletypeChange(e.target.value)
                            }
                            inputProps={{
                              name: 'location_type_id',
                              id: 'location_type_ids',
                            }}
                            variant='standard'>
                            {locationtype &&
                              locationtype.map((type, index) => (
                                <MenuItem
                                  key={index}
                                  value={type.id}
                                  selected
                                  className={classes.locationType}>
                                  {type.label}
                                </MenuItem>
                              ))}
                          </Select>
                          {hasError && (
                            <FormHelperText className={classes.selectLable}>
                              {t("Assign.SelectOneLocationType")}
                            </FormHelperText>
                          )}
                        </TableCell>
                        <TableCell
                          className={classes.layoutBorder}
                          sx={{ p: '0px' }}>
                          <InputLabel
                            htmlFor='box_id'
                            style={{ fontSize: '13px' }}>
                            {t('Unplugged.Location')}
                          </InputLabel>
                          <Select
                            style={{ marginTop: '6px' }}
                            fullWidth={true}
                            defaultValue={this.state.box_id || ''}
                            value={this.state.box_id || ''}
                            onChange={(e) => this.handleChange(e.target.value)}
                            inputProps={{
                              name: 'box_id',
                              id: 'box_ids',
                            }}
                            variant='standard'>
                            {this.state.boxdata.length > 0 &&
                              this.state.boxdata.map((type, index) => (
                                <MenuItem
                                  key={index}
                                  value={type.id}
                                  selected
                                  className={classes.locationType}>
                                  {type.value}
                                </MenuItem>
                              ))}
                          </Select>
                          {hasError && (
                            <FormHelperText className={classes.selectLable}>
                              {t("Assign.SelectOneBox")}
                            </FormHelperText>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.layoutBorder}
                          sx={{ p: '0px' }}>
                          <TextField
                            id='email'
                            type='email'
                            className={classes.textField}
                            fullWidth
                            margin='normal'
                            variant='standard'
                            label={t('Unplugged.Email')}
                            name='EmailID'
                            onChange={this.onInputChange}
                            InputLabelProps={{ shrink: true }}
                            value={this.state.EmailID}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                          />
                        </TableCell>
                        <TableCell
                          className={classes.layoutBorder}
                          sx={{ p: '0px' }}>
                          <TextField
                            id='phoneNo'
                            type='text'
                            className={classes.textField}
                            fullWidth
                            margin='normal'
                            variant='standard'
                            label={t('Unplugged.SMSPhone')}
                            name='phone'
                            onChange={this.onInputChange}
                            InputLabelProps={{ shrink: true, maxLength: 10 }}
                            value={this.state.phone}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                          />
                        </TableCell>
                        <TableCell
                          className={classes.layoutBorder}
                          sx={{ p: '0px' }}>
                          <TextField
                            id='address1'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Unplugged.Address1')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            value={this.validateFields(
                              searchedItems && searchedItems.AddressLine1
                            )}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                          />
                        </TableCell>
                        <TableCell
                          className={classes.layoutBorder}
                          sx={{ p: '0px' }}>
                          <TextField
                            id='address2'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Unplugged.Address2')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            value={this.validateFields(
                              searchedItems && searchedItems.AddressLine2
                            )}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.layoutBorder}
                          sx={{ p: '0px' }}>
                          <TextField
                            id='dateOfBirth'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Unplugged.DOB')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            autoComplete='off'
                            value={this.validateFields(
                              searchedItems && searchedItems.DateOfBirth
                            )}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                          />
                        </TableCell>
                        {this.state.locationtype_id === LOCATION_TYPE.Kiosk ? this.is_pre_assignment ? (
                          <TableCell className={classes.layoutBorder}>
                            <InputLabel
                              htmlFor='bin_size'
                              style={{ fontSize: '13px' }}
                            >
                              {t('Unplugged.BinSize')}
                              {this.state.isBinSizeRequired && <span style={{ marginLeft: '10px', fontSize: '13px', color: 'red' }}>
                                {t('Validation.Required')}
                              </span>}
                            </InputLabel>
                            <Select
                              style={{ marginTop: '5px' }}
                              fullWidth={true}
                              value={this.state.selectedBinSize}
                              onChange={this.handleBinSizeChange}
                              inputProps={{
                                name: 'bin_size',
                                id: 'bin_sizes',
                              }}
                              variant='standard'
                            >
                              {this.BinSizes && this.BinSizes.map((size, index) => (
                                <MenuItem
                                  key={index}
                                  value={size}
                                  selected
                                  className={classes.locationType}
                                >
                                  {binSizeTranslationObj[size]}
                                </MenuItem>
                              ))}
                            </Select>
                          </TableCell>)
                          : (
                            <TableCell
                              className={classes.layoutBorder}
                              sx={{ p: '0px' }}>
                              <TextField
                                id='bin'
                                type='text'
                                className={classes.textField}
                                margin='normal'
                                variant='standard'
                                label={this.state.isBinIdRequired ? (
                                  <span>
                                    <Typography variant="body1" component="span" color="inherit">
                                      {t('Unplugged.BIN')}
                                    </Typography>{' '}
                                    <Typography variant="body1" component="span" color="error">
                                      {t("Validation.Required")}
                                    </Typography>
                                  </span>
                                ) : (
                                  <span>
                                    <Typography variant="body1" component="span" color="rgba(0, 0, 0, 0.6)">
                                      {t('Unplugged.BIN')}
                                    </Typography>
                                  </span>
                                )}
                                fullWidth
                                InputLabelProps={this.state.isBinIdRequired ? { shrink: true, style: { color: 'inherit' } } : { shrink: true }}
                                value={selectedBinId}
                                inputProps={{
                                  autocomplete: 'off',
                                  form: {
                                    autocomplete: 'off',
                                  },
                                }}
                                error={this.state.isBinIdRequired}
                              />
                            </TableCell>)
                          : null}
                        <TableCell
                          className={classes.layoutBorder}
                          sx={{ p: '0px' }}>
                          <TextField
                            id='city'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Unplugged.City')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            value={this.validateFields(
                              searchedItems && searchedItems.City
                            )}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                          />
                        </TableCell>
                        {this.state.locationtype_id === LOCATION_TYPE.Kiosk ? (
                          ''
                        ) : (
                          <TableCell
                            className={classes.layoutBorder}
                            sx={{ p: '0px' }}>
                            <TextField
                              id='zip'
                              type='text'
                              className={classes.textField}
                              margin='normal'
                              variant='standard'
                              label={t('Unplugged.Zip')}
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              autoComplete='off'
                              value={this.validateFields(
                                searchedItems && searchedItems.Zip
                              )}
                              inputProps={{
                                autocomplete: 'off',
                                form: {
                                  autocomplete: 'off',
                                },
                              }}
                            />
                          </TableCell>
                        )}
                        <TableCell
                          className={classes.layoutBorder}
                          sx={{ p: '0px' }}>
                          <TextField
                            id='state'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Unplugged.State')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            autoComplete='off'
                            value={this.validateFields(
                              searchedItems && searchedItems.State
                            )}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.layoutBorder}
                          sx={{ p: '0px' }}>
                          <TextField
                            required
                            error={this.state.isPatientRecordNumberRequired}
                            id='Patient Record Number'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Unplugged.PatientRecordNumber')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            value={this.BindPatientId('')}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                          />
                        </TableCell>
                        <TableCell
                          className={classes.layoutBorder}
                          sx={{ p: '0px' }}>
                          </TableCell>
                        {this.state.locationtype_id === LOCATION_TYPE.Kiosk ? (
                          <TableCell
                            className={classes.layoutBorder}
                            sx={{ p: '0px' }}>
                            <TextField
                              id='zip'
                              type='text'
                              className={classes.textField}
                              margin='normal'
                              variant='standard'
                              label={t('Unplugged.Zip')}
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              value={this.validateFields(
                                searchedItems && searchedItems.Zip
                              )}
                              inputProps={{
                                autocomplete: 'off',
                                form: {
                                  autocomplete: 'off',
                                },
                              }}
                            />
                          </TableCell>
                        ) : (
                          <TableCell
                            className={classes.layoutBorder}
                            sx={{ p: '0px' }}></TableCell>
                        )}
                        <TableCell
                          className={classes.layoutBorder}
                          sx={{ p: '0px' }}>
                          <TextField
                            id='country'
                            type='text'
                            className={classes.textField}
                            margin='normal'
                            variant='standard'
                            label={t('Unplugged.Country')}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            value={this.validateFields(
                              searchedItems && searchedItems.Country
                            )}
                            inputProps={{
                              autocomplete: 'off',
                              form: {
                                autocomplete: 'off',
                              },
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
                <Box component='div' sx={{ mt: '-45px' }}>
                  <EnhancedTableToolbar
                    numSelected={selected.length}
                    deleteItems={this.deleteItems}
                    confirmDelete={this.confirmDelete}
                  />
                  <div className={classes.handleOverflow}>
                    <Table
                      className={classes.table}
                      aria-labelledby='tableTitle'>
                      <EnhancedTableHead
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={this.handleSelectAllClick}
                        onRequestSort={this.handleRequestSort}
                        rowCount={
                          this.state.scanRxItems
                            ? this.state.scanRxItems.length
                            : 0
                        }
                        isVisibleForPause={this.state.isVisibleForPause}
                        className={classes.tableCellLabel}
                      />
                      <TableBody>
                        {this.state.scanRxItems.length === 0 ? (
                          <TableRow>
                            <TableCell
                              className={classes.emptyRowCell}
                              style={{ padding: '10px 0px' }}
                              colSpan='9'>
                              {t('Unplugged.NoDataFound')}
                            </TableCell>
                          </TableRow>
                        ) : (
                          stableSort(
                            this.state.scanRxItems,
                            getSorting(order, orderBy)
                          ).map((row, index) => {
                            const isSelected = this.isSelected(
                              this.state.scanRxItems[index].rxNo
                            );
                            return (
                              <TableRow
                                hover
                                role='checkbox'
                                aria-checked={isSelected}
                                tabIndex={-1}
                                key={index}
                                selected={isSelected}>
                                {!this.state.isVisibleForPause && (
                                  <TableCell
                                    padding='checkbox'
                                    onClick={(event) =>
                                      this.handleClick(
                                        event,
                                        this.state.scanRxItems[index].rxNo,
                                        index
                                      )
                                    }
                                    style={{ padding: 0, textAlign: 'center' }}>
                                    <Checkbox
                                      checked={isSelected}
                                      style={{ color: '#4fc3f7' }}
                                    />
                                  </TableCell>
                                )}
                                <TableCell
                                  sx={{
                                    p: '0px',
                                    pl: '5px',
                                    pr: '0px',
                                    textAlign: 'left',
                                  }}>
                                  <TextField
                                    id='rxNo'
                                    type='text'
                                    className={classes.textField}
                                    fullWidth
                                    margin='normal'
                                    variant='standard'
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{
                                      autocomplete: 'off',
                                      form: {
                                        autocomplete: 'off',
                                      },
                                      readOnly: Boolean(this.state.readOnly),
                                    }}
                                    value={this.state.scanRxItems[index].rxNo}
                                    sx={{
                                      pr: '10px',
                                      '.MuiInput-root': { fontSize: '0.80rem' },
                                    }}
                                    onBlur={(e) => {
                                      if (this.state.isEdit === false)
                                        this.onRXValidate(index, 'rxNo', e.target.value);
                                    }}
                                    onChange={(e) =>
                                      this.onScanRxChange(index, 'rxNo', e.target.value)
                                    }
                                  />
                                </TableCell>
                                <TableCell
                                  className={classes.tableCell}
                                  sx={{ padding: 0, textAlign: 'left' }}>
                                  <TextField
                                    id='drugname'
                                    type='text'
                                    fullWidth
                                    className={classes.textField}
                                    margin='normal'
                                    variant='standard'
                                    inputProps={{
                                      autocomplete: 'off',
                                      form: {
                                        autocomplete: 'off',
                                      },
                                      readOnly: Boolean(this.state.readOnly),
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    value={
                                      this.state.scanRxItems[index].drugname
                                    }
                                    sx={{
                                      pr: '10px',
                                      '.MuiInput-root': { fontSize: '0.80rem' },
                                    }}
                                    onChange={(e) =>
                                      this.onScanRxChange(
                                        index,
                                        'drugname',
                                        e.target.value
                                      )
                                    }
                                  />
                                </TableCell>
                                <TableCell
                                  className={classes.tableCell}
                                  sx={{ padding: 0, textAlign: 'left' }}>
                                  <TextField
                                    id='ndccode'
                                    type='text'
                                    fullWidth
                                    className={classes.textField}
                                    margin='normal'
                                    variant='standard'
                                    inputProps={{
                                      readOnly: Boolean(this.state.readOnly),
                                      autocomplete: 'off',
                                      form: {
                                        autocomplete: 'off',
                                      },
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    value={
                                      this.state.scanRxItems[index].ndcCode
                                    }
                                    sx={{
                                      pr: '10px',
                                      '.MuiInput-root': { fontSize: '0.80rem' },
                                    }}
                                    onChange={(e) =>
                                      this.onScanRxChange(
                                        index,
                                        'ndcCode',
                                        e.target.value
                                      )
                                    }
                                  />
                                </TableCell>
                                <TableCell
                                  className={classes.tableCell}
                                  sx={{ padding: 0, textAlign: 'left' }}>
                                  <TextField
                                    id='qty'
                                    type='number'
                                    fullWidth
                                    className={classes.textField}
                                    margin='normal'
                                    variant='standard'
                                    inputProps={{
                                      inputMode: 'numeric',
                                      pattern: '[0-9]*',
                                      readOnly: Boolean(this.state.readOnly),
                                      min: 0,
                                      autocomplete: 'off',
                                      form: {
                                        autoComplete: 'off',
                                      },
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                    value={this.state.scanRxItems[index].qty}
                                    sx={{
                                      pr: '10px',
                                      '.MuiInput-root': { fontSize: '0.80rem' },
                                    }}
                                    onChange={(e) =>
                                      this.onScanRxChange(
                                        index,
                                        'qty',
                                        e.target.value
                                      )
                                    }
                                  />
                                </TableCell>
                                {this.state.accountDetails.bypass_consult ? (
                                  <TableCell
                                    className={classes.TableCell}></TableCell>
                                ) : (
                                  <TableCell
                                    sx={{ padding: 0, textAlign: 'left' }}
                                    className={classes.tableCell}>
                                    {' '}
                                    {this.state.scanRxItems[index] &&
                                      this.state.scanRxItems[index]
                                        .is_order_released &&
                                      this.state.scanRxItems[index]
                                        .is_order_released === true ? (
                                      <div>
                                        <img
                                          src={checked}
                                          alt={
                                            this.state.scanRxItems[index].rx_no
                                          }
                                          height={24}
                                          width={24}
                                        />
                                      </div>
                                    ) : (
                                      <div>
                                        {this.state.scanRxItems[index] &&
                                          this.state.scanRxItems[index]
                                            .is_order_released &&
                                          this.state.scanRxItems[index]
                                            .is_order_released}
                                        {this.state.isLoadingTrans === true ? (
                                          <img
                                            src={cl}
                                            alt='loader'
                                            width='36'
                                          />
                                        ) : (
                                          <Checkbox
                                            checked={
                                              this.state.scanRxItems[index]
                                                .ConsultRequire ||
                                              this.state.scanRxItems[index]
                                                .is_consultrequire
                                            }
                                            onChange={() =>
                                              this.handleConsultrequire(index)
                                            }
                                            value={
                                              this.state.scanRxItems[index]
                                                .ConsultRequire ||
                                              this.state.scanRxItems[index]
                                                .is_consultrequire
                                            }
                                            color='primary'
                                          />
                                        )}
                                      </div>
                                    )}
                                  </TableCell>
                                )}
                                <TableCell
                                  className={classes.tableCell}
                                  sx={{ padding: 0, textAlign: 'left' }}>
                                  <div>
                                    <span style={{ fontSize: '0.80rem' }}>
                                      {this.state.indexNo !== index &&
                                        this.state.isEdit === true &&
                                        this.state.isAmountPaid === false
                                        ? '$' +
                                        parseFloat(
                                          this.state.scanRxItems[index][
                                          'price'
                                          ]
                                        ).toFixed(2)
                                        : ''}
                                      {this.state.isEdit === true &&
                                        this.state.isAmountPaid === false ? (
                                        this.state.indexNo === index ? (
                                          <React.Fragment>
                                            <TextField
                                              sx={{
                                                width: '60px',
                                                mt: '7px',
                                                '.MuiInput-root': {
                                                  fontSize: '0.80rem',
                                                },
                                              }}
                                              value={parseFloat(
                                                this.state.scanRxItems[index][
                                                'price'
                                                ]
                                              )}
                                              variant='standard'
                                              onChange={(e) =>
                                                this.onHandleChangeInputValue(
                                                  this.state.scanRxItems[index][
                                                  'id'
                                                  ],
                                                  'price',
                                                  e.target.value
                                                )
                                              }
                                              id='price'
                                              InputProps={{
                                                inputComponent: NumberFormatCustom,
                                                autocomplete: 'off',
                                                form: {
                                                  autocomplete: 'off',
                                                },
                                              }}
                                            />
                                            <Tooltip
                                              title={t(
                                                'Unplugged.SaveTooltip'
                                              )}>
                                              <IconButton
                                                onClick={() =>
                                                  this.handleCloseDueAmountEditInput(
                                                    index,
                                                    this.state.scanRxItems[
                                                    index
                                                    ]['orderid']
                                                  )
                                                }
                                                className={
                                                  classes.onAmoutDueEditPrimaryButton
                                                }
                                                sx={{
                                                  float: 'right',
                                                  ml: '-15px',
                                                }}>
                                                <SaveIcon />
                                              </IconButton>
                                            </Tooltip>
                                          </React.Fragment>
                                        ) : (
                                          <Tooltip
                                            title={t('Unplugged.EditTooltip')}>
                                            <IconButton
                                              className={
                                                classes.onAmoutDueEditPrimaryButton
                                              }
                                              onClick={() =>
                                                this.handleOpenDueAmountEditInput(
                                                  index
                                                )
                                              }
                                              sx={{ ml: '6%' }}>
                                              <EditIcon />
                                            </IconButton>
                                          </Tooltip>
                                        )
                                      ) : (
                                        <AmountFormat
                                          setStyle={'70px'}
                                          id='price'
                                          onBlur={(e) =>
                                            this.onScanRxChange(
                                              index,
                                              'price',
                                              e.target.value
                                            )
                                          }
                                          defaultValue={
                                            this.state.scanRxItems[index].price
                                          }
                                          value={this.state.price}
                                          readOnly={this.state.readOnly}
                                        />
                                      )}
                                    </span>
                                  </div>
                                </TableCell>
                                <TableCell>
                                  <Checkbox
                                    onChange={() => this.handleIsReturnable(index)}
                                    value={this.state.scanRxItems[index].IsReturnable || this.state.scanRxItems[index].is_returnable}
                                    checked={ this.state.scanRxItems[index].IsReturnable || this.state.scanRxItems[index].is_returnable }
                                    color="primary"
                                  />
                                </TableCell>
                                <TableCell>
                                  <Checkbox
                                    onChange={() => this.handleIsControlledSubstance(index)}
                                    value={ this.state.scanRxItems[index].is_controlledsubstances }
                                    checked={ this.state.scanRxItems[index].is_controlledsubstances }
                                    color="primary"
                                  />
                                </TableCell>
                              </TableRow>
                            );
                          })
                        )}
                      </TableBody>
                    </Table>
                  </div>
                </Box>
                {this.state.isVisibleForPause ? (
                  <Table
                    aria-labelledby='tableTitle'
                    style={{ marginTop: '2%' }}>
                    <TableRow style={{ height: 40 }}>
                      <TableCell className={classes.padiGridCell}>
                        &nbsp;
                      </TableCell>
                      <TableCell className={classes.padiGridCell}>
                        &nbsp;
                      </TableCell>
                      <TableCell className={classes.padiGridCell}>
                        &nbsp;
                      </TableCell>
                      <TableCell className={classes.padiGridCell}>
                        &nbsp;
                      </TableCell>
                      <TableCell className={classes.padiGridCell}>
                        &nbsp;
                      </TableCell>
                      <TableCell className={classes.padiGridCell}>
                        &nbsp;
                      </TableCell>
                      <TableCell className={classes.padiGridCell}>
                        &nbsp;
                      </TableCell>
                      <TableCell className={classes.padiGridCell}>
                        {t('Unplugged.Paid')}
                      </TableCell>
                      <TableCell style={{ textAlign: 'left' }}>
                        {this.state && this.state.isAmountPaid === true
                          ? this.getDueAmount()
                          : `$${(0).toFixed(2)}`}
                      </TableCell>
                    </TableRow>
                    <TableRow style={{ height: 40 }}>
                      <TableCell className={classes.padiGridCell}>
                        &nbsp;
                      </TableCell>
                      <TableCell className={classes.padiGridCell}>
                        &nbsp;
                      </TableCell>
                      <TableCell className={classes.padiGridCell}>
                        &nbsp;
                      </TableCell>
                      <TableCell className={classes.padiGridCell}>
                        &nbsp;
                      </TableCell>
                      <TableCell className={classes.padiGridCell}>
                        &nbsp;
                      </TableCell>
                      <TableCell className={classes.padiGridCell}>
                        &nbsp;
                      </TableCell>
                      <TableCell className={classes.padiGridCell}>
                        &nbsp;
                      </TableCell>
                      <TableCell className={classes.padiGridCell}>
                        {t('Unplugged.AmountDue')}
                      </TableCell>
                      <TableCell style={{ textAlign: 'left' }}>
                        {this.state && this.state.isAmountPaid === false
                          ? this.getDueAmount()
                          : `$${(0).toFixed(2)}`}
                      </TableCell>
                    </TableRow>
                  </Table>
                ) : (
                  <div></div>
                )}
                <div className={classes.buttonContainer}>
                  {(is_stocked || isAlreadyAssigned || isAlreadyOnHold) && itemCount !== 0 ? (
                    <div>
                      <Button
                        type='button'
                        color='primary'
                        variant='contained'
                        className={classes.primaryButton}
                        // disabled={(itemCount === 0 ? true : false) || (this.state && this.state.isLoadingTrans === true)}
                        onClick={() => this.reminderHandler()}>
                        {t('Unplugged.Remind')}
                      </Button>
                      &nbsp;
                      <Button
                        type='button'
                        color='primary'
                        variant='contained'
                        className={classes.primaryButton}
                        // disabled={(itemCount === 0 ? true : false) || (this.state && this.state.isLoadingTrans === true)}
                        onClick={() => this.handleConsultClick()}>
                        {t('Unplugged.Consult')}
                      </Button>
                    </div>
                  ) : (
                    ''
                  )}
                  &nbsp;
                  <Button
                    type='button'
                    color='primary'
                    variant='contained'
                    className={classes.primaryButton}
                    disabled={
                      (itemCount === 0 ? true : false) ||
                      (this.state && this.state.isLoadingTrans === true)
                    }
                    onClick={() => this.ClearFields('clear')}>
                    {t('Unplugged.Clear')}
                  </Button>
                  &nbsp;
                  {!this.state.isVisibleForPause ? (
                    <div>
                      <Button
                        type='button'
                        color='primary'
                        variant='contained'
                        className={classes.primaryButton}
                        disabled={
                          (itemCount === 0 ? true : false) ||
                          (this.state && this.state.isLoadingTrans === true)
                        }
                        onClick={() => this.ManualPickupNotification(0)}>
                        {t('Unplugged.DirectPickup')}
                      </Button>
                      &nbsp;
                      <Button
                        type='button'
                        color='primary'
                        variant='contained'
                        className={classes.primaryButton}
                        disabled={
                          (itemCount === 0 ? true : false) ||
                          (this.state && this.state.isLoadingTrans === true)
                        }
                        onClick={() => this.checkIfBinIsOccupedFromAnotherLocation(0)}>
                        {t('Unplugged.Save')}
                      </Button>
                      &nbsp;
                      <Button
                        type='button'
                        color='primary'
                        variant='contained'
                        className={classes.primaryButton}
                        disabled={
                          (itemCount === 0 ? true : false) ||
                          (this.state && this.state.isLoadingTrans === true)
                        }
                        onClick={() => this.checkIfBinIsOccupedFromAnotherLocation(1)}>
                        {t('Unplugged.SavePrint')}
                      </Button>
                    </div>
                  ) : (
                    <div>
                      {!isAlreadyOnHold ? (
                        <div>
                          {isAlreadyAssigned && (
                            <React.Fragment>
                              <Button
                                type='button'
                                color='primary'
                                variant='contained'
                                className={classes.primaryButton}
                                disabled={
                                  (itemCount === 0 ? true : false) ||
                                  (this.state &&
                                    this.state.isLoadingTrans === true)
                                }
                                onClick={() =>
                                  this.ManualPickupNotification(1)
                                }>
                                {t('Unplugged.DirectPickup')}
                              </Button>
                              &nbsp;
                              <Button
                                type='button'
                                color='primary'
                                variant='contained'
                                className={classes.primaryButton}
                                onClick={() => this.changeOrderStatus('remove')}
                                disabled={isAlreadyOnHold ? true : false}>
                                <i
                                  className={classes.pauseButton}
                                  style={{ margin: '2.5px' }}>
                                  remove
                                </i>
                              </Button>
                            </React.Fragment>
                          )}
                          {!isAlreadyAssigned && (
                            <Button
                              type='button'
                              color='primary'
                              variant='contained'
                              className={classes.primaryButton}
                              disabled={
                                (itemCount === 0 ? true : false) ||
                                (this.state &&
                                  this.state.isLoadingTrans === true)
                              }
                              onClick={() => this.ManualPickupNotification(2)}>
                              {t('Unplugged.DirectPickup')}
                            </Button>
                          )}
                          &nbsp;
                          <Button
                            type='button'
                            color='primary'
                            variant='contained'
                            className={classes.primaryButton}
                            onClick={() => this.changeOrderStatus('pause')}
                            disabled={
                              isAlreadyOnHold || isAlreadyAssigned
                                ? true
                                : false
                            }>
                            <i
                              className={classes.pauseButton}
                              style={{ margin: '2.5px' }}>
                              pause
                            </i>
                          </Button>
                          &nbsp;
                          <Button
                            type='button'
                            color='primary'
                            variant='contained'
                            className={classes.primaryButton}
                            onClick={() => this.handlePrintReceipt()}>
                            {t('Unplugged.PrintLabel')}
                          </Button>
                          &nbsp;
                        </div>
                      ) : (
                        <div>
                          <Button
                            type='button'
                            color='primary'
                            variant='contained'
                            className={classes.primaryButton}
                            disabled={
                              (itemCount === 0 ? true : false) ||
                              (this.state && this.state.isLoadingTrans === true)
                            }
                            onClick={() => this.ManualPickupNotification(3)}>
                            {t('Unplugged.DirectPickup')}
                          </Button>
                          &nbsp;
                          <Button
                            type='button'
                            color='primary'
                            variant='contained'
                            className={classes.primaryButton}
                            onClick={() => this.changeOrderStatus('play')}
                            disabled={!isAlreadyOnHold ? true : false}>
                            <PlayArrow
                              className={classes.pauseButton}
                              style={{ margin: '2.5px' }}
                            />
                          </Button>
                          &nbsp;
                          <Button
                            type='button'
                            color='primary'
                            variant='contained'
                            className={classes.primaryButton}
                            onClick={() => this.handlePrintReceipt()}>
                            {t('Unplugged.PrintLabel')}
                          </Button>
                          &nbsp;
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div
                id='react-no-print'
                key='BoxLayout'
                className={classes.boxHolder}>
                <Box
                  component='div'
                  id='react-no-print'
                  sx={{ position: 'absolute', top: '60px', right: '20px' }}>
                  <TextField
                    id='idsearchtxt'
                    margin='normal'
                    variant='standard'
                    value={this.state.searchObj.searchTxt}
                    label={t('Unplugged.Search')}
                    InputProps={{
                      inputProps: { autocomplete: 'off' },
                      form: {
                        autocomplete: 'off',
                      },
                      startAdornment: (
                        <InputAdornment position='start'>
                          <MagnifyIcon />
                        </InputAdornment>
                      ),
                    }}
                    onChange={this.onSearchChange}
                    inputRef={this.textInput}
                    sx={{ width: '8cm' }}
                  />
                </Box>

                {this.state.locationtype_id === LOCATION_TYPE.Kiosk ? (
                  <React.Fragment>
                    {this.is_pre_assignment ? (
                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Table sx={{ width: 'auto' }}>
                          <TableRow>
                            <TableCell sx={{ textAlign: 'center' }}>{t("Unplugged.BinSizes")}</TableCell>
                            <TableCell sx={{ textAlign: 'center' }}>{t("Unplugged.LargeBinSize")}</TableCell>
                            <TableCell sx={{ textAlign: 'center' }}>{t("Unplugged.MediumBinSize")}</TableCell>
                            <TableCell sx={{ textAlign: 'center' }}>{t("Unplugged.SmallBinSize")}</TableCell>
                            <TableCell sx={{ textAlign: 'center' }}>{t("Unplugged.CoolBinSize")}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ textAlign: 'center' }}>{t("Unplugged.AvailableBins")}</TableCell>
                            <TableCell sx={{ textAlign: 'center' }}>{this.state.largeBinsCount}</TableCell>
                            <TableCell sx={{ textAlign: 'center' }}>{this.state.mediumBinsCount}</TableCell>
                            <TableCell sx={{ textAlign: 'center' }}>{this.state.smallBinsCount}</TableCell>
                            <TableCell sx={{ textAlign: 'center' }}>{this.state.coolBinsCount}</TableCell>
                          </TableRow>
                        </Table>
                      </div>
                    ) : null}
                    <Grid container sx={this.is_pre_assignment ? { m: '0px' } : { m: '0px', mt: '8%' }}>
                      <Grid item xs={12}>
                        <Boxlayout
                          BinStatus={this.state.BinStatus}
                          deactivatedBins={this.state.deactivatedBins}
                          selectedBinId={this.state.selectedBinId}
                          expansionUnits={this.state.expansionUnits} //Added by Naresh | DI-329
                          getPrescriptionDetails={this.getPrescriptionDetails}
                          getSelectedBin={this.getSelectedBin}
                          getSelectedUnitName={this.getSelectedUnitName}
                          currentTabIndex={this.state.expansionUnits.findIndex(
                            (x) => x.pos === 'M' || x.pos === 'M22' || x.pos === 'FASTLANE' || x.pos === 'M24'
                          )}
                          isADACompatible={this.state.isADACompatible}
                          ADAData={this.state.ADAData}
                          PatientID={
                            this.state &&
                            this.state.searchedItems &&
                            this.state.searchedItems.PatientID
                          }
                          boxTypeId={this.state && this.state.boxTypeId}
                          is_pre_assignment={this.is_pre_assignment}
                          BoxID={this.state && this.state.box_id}
                          getAvailableBinsCount={this.getAvailableBinsCount}
                          makeAPICall={this.state.makePreAssignmentAPICall}
                          isViewPermissionAllowed={prescriptionView}
                        />
                      </Grid>
                    </Grid>
                    {!this.is_pre_assignment && <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <List sx={{ display: 'flex', flexDirection: 'row' }}>
                        {legend.map((value) => {
                          return (
                            <ListItem disablePadding sx={{ cursor: 'pointer', margin: '0 10px' }}>
                              <ListItemIcon>
                                <span style={{ background: value.color, height: '20px', width: '20px', border: '1px solid #888', borderRadius: '50%' }}>&nbsp;</span>
                              </ListItemIcon>
                              <ListItemText primary={value.label} />
                            </ListItem>
                          );
                        })}
                      </List>
                    </div>}
                    <Grid container sx={{ m: '0px', pl: '1rem', pr: '1rem', mb: '2rem' }}>
                      <Table>
                        <TableRow>
                          <TableCell className={classes.TableHeadTop}>
                            <span style={{ color: '#a4a6a5' }}>
                              {t("Unplugged.StockCode")}:
                            </span>
                            &nbsp;&nbsp; <span>{stockCode}</span>
                          </TableCell>
                          <TableCell className={classes.TableHeadTop}>
                            <span style={{ color: '#a4a6a5' }}>{t("Unplugged.PUCode")}:</span>
                            &nbsp;&nbsp; <span>{pickupCode}</span>
                          </TableCell>
                        </TableRow>
                      </Table>
                    </Grid>
                  </React.Fragment>
                ) : this.state.locationtype_id === LOCATION_TYPE.Home ? (
                  <Box
                    component='div'
                    sx={{ height: '100%', width: '100%', textAlign: 'center' }}>
                    <HomeIcon
                      style={{ height: '100%', width: '50%', color: '#0a5d66' }}
                    />
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Work ? (
                  <Box
                    component='div'
                    style={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                    }}>
                    <WorkIcon
                      style={{ height: '100%', width: '50%', color: '#0a5d66' }}
                    />
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Bedside ? (
                  <Box
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}>
                    <img
                      src={inpatientIcon}
                      style={{ height: '30%', width: '50%', color: '#0a5d66' }}
                      alt='no-icon'
                    />
                    <Grid container sx={{ m: '0px', pl: '1rem', pr: '1rem' }}>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.BedSide.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.BedSide.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.BedSide.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.BedSide.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ marginTop: '5%', textAlign: 'start' }}>
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Courier ? (
                  <Box
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}>
                    <img
                      src={courierIcon}
                      style={{ height: '30%', width: '50%', color: '#0a5d66' }}
                      alt='no-icon'
                    />
                    <Grid
                      container
                      spacing={2}
                      sx={{ pl: '0.5rem', pr: '0.5rem', mt: '-7%' }}>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Courier.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Courier.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      sx={{ pl: '0.5rem', pr: '0.5rem', mt: '1%' }}>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Courier.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Courier.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      sx={{ pl: '0.5rem', pr: '0.5rem', mt: '1%' }}>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Courier.Courier')}
                        </label>
                        {this.state.courier_type &&
                          this.state.courier_type.length > 0
                          ? this.state.courier_type.map((val) => {
                            return (
                              <div>
                                <FormControlLabel
                                  label={
                                    <span style={{ color: '#000' }}>
                                      {val}
                                    </span>
                                  }
                                  control={
                                    <Checkbox
                                      value={val}
                                      color='primary'
                                      checked={
                                        this.state
                                          .default_courier_selected === val
                                      }
                                      onClick={() =>
                                        this.checkBoxHandler(val)
                                      }
                                    />
                                  }
                                />
                              </div>
                            );
                          })
                          : ''}
                      </Grid>
                      <Grid item xs={6} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Courier.TrackingNumber')}
                        </label>
                        <br />
                        <input
                          type='text'
                          style={{
                            width: '100%',
                            borderRadius: '5px',
                            padding: '5px',
                            height: '45px',
                            fontSize: '15px',
                          }}
                          value={this.state.courier_tracking}
                          onChange={(evt) => this.courierTrackingHandler(evt)}
                          placeholder={t(
                            'Unplugged.Courier.ScanOrEnterTrackingNumber'
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ marginTop: '5%', textAlign: 'start' }}>
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Other ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}>
                    <img
                      src={curbsideIcon}
                      style={{ height: '30%', width: '50%', color: '#0a5d66' }}
                      alt='no-icon'
                    />
                    <Table
                      aria-labelledby='tableTitle'
                      style={{ marginTop: '-6%', textAlign: 'start' }}>
                      <TableRow>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Other.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </TableRow>
                      <br />
                      <TableRow>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Other.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </TableRow>
                      <br />
                      <TableRow>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Other.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </TableRow>
                      <br />
                      <TableRow>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Other.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </TableRow>
                      <br />
                      <TableRow>
                        <div className={classes.handleStcPic}>
                          <Table>
                            <TableRow>
                              <TableCell className={classes.TableHeadTop}>
                                <span style={{ color: '#a4a6a5' }}>
                                  {t("Unplugged.StockCode")}:
                                </span>
                                &nbsp;&nbsp; <span>{stockCode}</span>
                              </TableCell>
                              <TableCell className={classes.TableHeadTop}>
                                <span style={{ color: '#a4a6a5' }}>
                                  {t("Unplugged.PUCode")}:
                                </span>
                                &nbsp;&nbsp; <span>{pickupCode}</span>
                              </TableCell>
                            </TableRow>
                          </Table>
                        </div>
                      </TableRow>
                    </Table>
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Counter ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}>
                    <img
                      src={counterIcon}
                      style={{ height: '30%', width: '50%', color: '#0a5d66' }}
                      alt='no-icon'
                    />
                    <Grid container sx={{ m: '0px', pl: '1rem', pr: '1rem' }}>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Counter.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Counter.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Counter.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.Counter.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ marginTop: '5%', textAlign: 'start' }}>
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Curbside ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}>
                    <img
                      src={curbsideIcon}
                      style={{
                        height: '30%',
                        width: '50%',
                        marginTop: '-5%',
                        color: '#0a5d66',
                      }}
                      alt='no-icon'
                    />
                    <Grid container sx={{ m: '0px', pl: '1rem', pr: '1rem' }}>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.CurbSide.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.CurbSide.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.CurbSide.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.CurbSide.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ marginTop: '5%', textAlign: 'start' }}>
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : this.state.locationtype_id === LOCATION_TYPE.Bedside ? (
                  <Box
                    component='div'
                    sx={{
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      mt: '2%',
                    }}>
                    <img
                      src={inpatientIcon}
                      style={{
                        height: '30%',
                        width: '50%',
                        marginTop: '-5%',
                        color: '#0a5d66',
                      }}
                      alt='no-icon'
                    />
                    <Grid container sx={{ m: '0px', pl: '1rem', pr: '1rem' }}>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.BedSide.StorageLocation')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='storage_location'
                          value={this.state.storage_location}
                          onChange={(e) =>
                            this.textInputHandler(
                              'storage_location',
                              e.target.value
                            )
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.BedSide.PatientOrderComment')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={
                            searchedItems && searchedItems.patient_order_comment
                              ? searchedItems.patient_order_comment
                              : ''
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.BedSide.OrderNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='order_notes'
                          value={this.state.order_notes}
                          onChange={(e) =>
                            this.textInputHandler('order_notes', e.target.value)
                          }
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'left' }}>
                        <label style={{ color: '#858585' }}>
                          {t('Unplugged.BedSide.LocationNotes')}
                        </label>
                        <br />
                        <textarea
                          rows='4'
                          cols='50'
                          name='delivery_notes'
                          value={
                            searchedItems && searchedItems.location_notes
                              ? searchedItems.location_notes
                              : ''
                          }
                          onChange={(e) =>
                            this.textInputHandler(
                              'delivery_notes',
                              e.target.value
                            )
                          }
                          readOnly={true}
                          className={classes.textArea}
                        />
                      </Grid>
                      <Grid xs={12} sx={{ textAlign: 'left' }}>
                        <Table
                          aria-labelledby='tableTitle'
                          sx={{ marginTop: '5%', textAlign: 'start' }}>
                          <TableRow>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.StockCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{stockCode}</span>
                            </TableCell>
                            <TableCell className={classes.TableHeadTop}>
                              <span style={{ color: '#a4a6a5' }}>
                                {t("Unplugged.PUCode")}:
                              </span>
                              &nbsp;&nbsp; <span>{pickupCode}</span>
                            </TableCell>
                          </TableRow>
                        </Table>
                      </Grid>
                    </Grid>
                  </Box>
                ) : (
                  ''
                )}
              </div>
              {this.state.detailDialogOpen ? (
                <Manualconsultation
                  detailDialogOpen={this.state.detailDialogOpen}
                  selectedObject={this.state.searchedItems}
                  stockCode={stockCode}
                  pickupCode={pickupCode}
                  boxId={this.state.box_id}
                  accountDetails={this.state.accountDetails}
                  pharmacyDetails={this.state.pharmacyDetails}
                  onPopupClose={this.handleConsultClose}
                />
              ) : null}
            </div>
          </div>

          <Box component='div' id='react-no-print'>
            <Dialog
              open={(this.state && this.state.showDialog) || false}
              aria-labelledby='form-dialog-title'>
              <DialogTitle id='form-dialog-title'>
                {t('Unplugged.Popup.EnterDetails')}
              </DialogTitle>
              <DialogContent>
                <FormControl variant='standard' fullWidth>
                  <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                    <DesktopDatePicker
                      disableFuture
                      value={this.state.popupDOB}
                      onChange={this.onDateSelect}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t('Unplugged.Popup.DOB')}
                          variant='standard'
                          autoFocus
                          allowKeyboardControl={true}
                          onBlur={this.handleBlurdob}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </FormControl>
                <FormControl variant='standard' sx={{ mt: '4%' }} fullWidth>
                  <InputLabel htmlFor='formatted-text-mask-input'>
                    {t('Unplugged.Popup.PhoneNumber')}
                  </InputLabel>
                  <Input
                    onChange={this.handlePhoneChange}
                    onKeyDown={(e) => this.handleKeyDown(e)}
                    value={this.state.popupphone}
                    name='Phone Number'
                    id='formatted-text-mask-input'
                    autoComplete='off'
                    inputComponent={TextMaskCustom}
                  />
                </FormControl>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={this.handleDialogClose}
                  color='primary'
                  className={classes.primaryButton}>
                  {t('Unplugged.Popup.Close')}
                </Button>
                <Button
                  type='submit'
                  onClick={this.handleDialogValidate}
                  color='primary'
                  className={classes.primaryButton}>
                  {t('Unplugged.Popup.Validate')}
                </Button>
              </DialogActions>
              {/* </ValidatorForm> */}
            </Dialog>
          </Box>

          <Box component='div' id='react-no-print'>
            <Dialog
              open={(this.state && this.state.showCoPayAmountDialog) || false}
              aria-labelledby='form-dialog-title'>
              <DialogTitle id='form-dialog-title'>
                {t('Unplugged.CoPayAmount')}
              </DialogTitle>
              <DialogContent>
                <AmountFormat
                  style={{ width: '70px' }}
                  id='CoPayAmount'
                  onBlur={(e) =>
                    this.handleCoPayAmountDialogClose(
                      this.state.CoPayAmountIndex,
                      'CoPayAmount',
                      e.target.value
                    )
                  }
                  defaultValue={this.state.CoPayAmountValue}
                  readOnly={this.state.readOnly}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  type='submit'
                  onClick={(e) =>
                    this.handleCoPayAmountDialogClose(
                      this.state.CoPayAmountIndex,
                      'ok',
                      false
                    )
                  }
                  color='primary'
                  className={classes.primaryButton}>
                  {t('Unplugged.OK')}
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
          <div id='react-no-print' className={classes.root}>
            <Dialog
              open={this.state.isVerifyingBin || false}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'>
              <DialogTitle id='alert-dialog-title'>
                {t('Unplugged.BinStatus')}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id='alert-dialog-description'>
                  {this.state && this.state.isVerifyingBinMessage}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={this.confirmBinOkButton}
                  color='primary'
                  className={classes.primaryButton}>
                  {t('Unplugged.Okay')}
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </Paper>

        {/* Print Label Functionality  */}
        <Box component='div' id='Print_UnpluggedPrescription_Label'>
          <PrintTemplate>
            <Dialog
              open={this.state.printDialogOpen || false}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
              PaperProps={{
                sx: { borderRadius: '0px', width: '255px', height: '430px' },
              }}>
              <DialogContent sx={{ p: '10px' }}>
                <LabelTemplate
                  style={{ display: 'none' }}
                  stockCode={stockCode || ''}
                  pickupCode={pickupCode || ''}
                  rxNumbers={searchedRxNumbers || ''}
                  boxId={this.state.box_id || ''}
                  ref={(el) => (this.componentRef = el)}
                  accountDetails={this.state.accountDetails || ''}
                  pharmacyDetails={this.state.pharmacyDetails || ''}
                  firstName={this.state.PrintFirstName || ''}
                  lastName={this.state.PrintLastName || ''}
                  dateOfBirth={this.state.PrintDateOfBirth || ''}
                  isCoolItem={this.state.PrintisCoolItem || ''}
                  prefer_location_name={this.state.prefer_location_name || ''}
                  locationTypeID={this.state.locationtype_id || ''}
                  brandingName={this.state.brandName || ''}
                  brandingPhone={this.state.brandPhone || ''}
                  boxDetails={this.state.boxdata}
                  connectionType={1}
                  t={t}
                />
              </DialogContent>
            </Dialog>
          </PrintTemplate>
        </Box>
      </Box>
    );
  }
}

export default withStyles(styles)(withTranslation()(AssignPrescriptions));



// WEBPACK FOOTER //
// ./src/components/unplugged-assign-prescriptions/index.js